package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Cambodia Flag (16x12dp)
 *
 * - ISO Alpha-2: KH
 * - ISO Alpha-3: KHM
 * - ISO Numeric: 116
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.Cambodia: ImageVector by lazy {
    ImageVector.Builder(
        name = "Cambodia:KH:KHM:116:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(fill = SolidColor(Color(0xFF032EA1))) {
                moveTo(0f, 0f)
                horizontalLineTo(16f)
                verticalLineTo(12f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(fill = SolidColor(Color(0xFFE00025))) {
                moveTo(0f, 3f)
                horizontalLineTo(16f)
                verticalLineTo(9f)
                horizontalLineTo(0f)
                verticalLineTo(3f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.167f, 5.52f)
                verticalLineTo(5.55f)
                horizontalLineTo(6.112f)
                verticalLineTo(5.52f)
                horizontalLineTo(7.435f)
                verticalLineTo(5.58f)
                horizontalLineTo(8.323f)
                verticalLineTo(5.52f)
                horizontalLineTo(9.649f)
                verticalLineTo(5.55f)
                horizontalLineTo(10.594f)
                verticalLineTo(5.52f)
                horizontalLineTo(10.704f)
                verticalLineTo(6.826f)
                horizontalLineTo(5.004f)
                verticalLineTo(5.52f)
                horizontalLineTo(5.167f)
                close()
                moveTo(5.004f, 6.826f)
                horizontalLineTo(4.702f)
                verticalLineTo(7.075f)
                horizontalLineTo(5.392f)
                verticalLineTo(7.08f)
                horizontalLineTo(4.396f)
                verticalLineTo(7.506f)
                horizontalLineTo(5.392f)
                verticalLineTo(7.51f)
                horizontalLineTo(4.201f)
                verticalLineTo(7.885f)
                horizontalLineTo(11.56f)
                verticalLineTo(7.51f)
                horizontalLineTo(10.366f)
                verticalLineTo(7.506f)
                horizontalLineTo(11.368f)
                verticalLineTo(7.08f)
                horizontalLineTo(10.366f)
                verticalLineTo(7.075f)
                horizontalLineTo(11.062f)
                verticalLineTo(6.826f)
                horizontalLineTo(10.704f)
                verticalLineTo(6.834f)
                horizontalLineTo(5.004f)
                verticalLineTo(6.826f)
                close()
                moveTo(10.594f, 5.52f)
                verticalLineTo(4.68f)
                curveTo(10.58f, 4.68f, 10.57f, 4.7f, 10.559f, 4.725f)
                curveTo(10.541f, 4.762f, 10.519f, 4.809f, 10.468f, 4.809f)
                curveTo(10.423f, 4.809f, 10.426f, 4.755f, 10.453f, 4.713f)
                curveTo(10.474f, 4.674f, 10.501f, 4.623f, 10.465f, 4.524f)
                curveTo(10.438f, 4.599f, 10.372f, 4.623f, 10.384f, 4.578f)
                curveTo(10.391f, 4.552f, 10.401f, 4.533f, 10.412f, 4.516f)
                curveTo(10.434f, 4.477f, 10.453f, 4.443f, 10.42f, 4.359f)
                curveTo(10.405f, 4.461f, 10.339f, 4.458f, 10.354f, 4.398f)
                curveTo(10.358f, 4.381f, 10.364f, 4.367f, 10.369f, 4.353f)
                curveTo(10.386f, 4.311f, 10.399f, 4.276f, 10.363f, 4.203f)
                curveTo(10.336f, 4.314f, 10.303f, 4.308f, 10.303f, 4.239f)
                curveTo(10.303f, 4.137f, 10.303f, 4.029f, 10.177f, 3.99f)
                curveTo(10.177f, 3.99f, 10.168f, 3.9f, 10.12f, 3.9f)
                curveTo(10.075f, 3.9f, 10.066f, 3.99f, 10.066f, 3.99f)
                curveTo(9.94f, 4.028f, 9.94f, 4.135f, 9.94f, 4.232f)
                curveTo(9.94f, 4.235f, 9.94f, 4.237f, 9.94f, 4.239f)
                curveTo(9.94f, 4.308f, 9.907f, 4.314f, 9.88f, 4.203f)
                curveTo(9.844f, 4.276f, 9.857f, 4.311f, 9.874f, 4.353f)
                curveTo(9.879f, 4.367f, 9.885f, 4.381f, 9.889f, 4.398f)
                curveTo(9.904f, 4.458f, 9.838f, 4.461f, 9.823f, 4.359f)
                curveTo(9.79f, 4.443f, 9.809f, 4.477f, 9.831f, 4.516f)
                curveTo(9.842f, 4.533f, 9.852f, 4.552f, 9.859f, 4.578f)
                curveTo(9.871f, 4.623f, 9.805f, 4.599f, 9.778f, 4.524f)
                curveTo(9.742f, 4.623f, 9.769f, 4.674f, 9.79f, 4.713f)
                curveTo(9.814f, 4.755f, 9.82f, 4.809f, 9.775f, 4.809f)
                curveTo(9.724f, 4.809f, 9.702f, 4.763f, 9.684f, 4.727f)
                curveTo(9.673f, 4.703f, 9.663f, 4.683f, 9.649f, 4.683f)
                verticalLineTo(5.52f)
                horizontalLineTo(10.594f)
                close()
                moveTo(8.323f, 5.52f)
                horizontalLineTo(7.435f)
                verticalLineTo(5.415f)
                curveTo(7.435f, 5.369f, 7.41f, 5.347f, 7.388f, 5.326f)
                curveTo(7.369f, 5.309f, 7.351f, 5.292f, 7.351f, 5.265f)
                curveTo(7.351f, 5.265f, 7.339f, 5.175f, 7.363f, 5.133f)
                curveTo(7.396f, 5.253f, 7.453f, 5.232f, 7.453f, 5.181f)
                curveTo(7.453f, 5.142f, 7.428f, 5.103f, 7.369f, 5.015f)
                lineTo(7.354f, 4.992f)
                curveTo(7.33f, 4.959f, 7.345f, 4.854f, 7.375f, 4.815f)
                curveTo(7.387f, 4.905f, 7.402f, 4.95f, 7.441f, 4.95f)
                curveTo(7.465f, 4.95f, 7.483f, 4.935f, 7.483f, 4.89f)
                curveTo(7.483f, 4.852f, 7.467f, 4.826f, 7.45f, 4.798f)
                curveTo(7.441f, 4.782f, 7.431f, 4.766f, 7.423f, 4.746f)
                curveTo(7.402f, 4.691f, 7.415f, 4.629f, 7.456f, 4.587f)
                curveTo(7.459f, 4.603f, 7.461f, 4.617f, 7.463f, 4.629f)
                lineTo(7.463f, 4.629f)
                curveTo(7.471f, 4.689f, 7.475f, 4.713f, 7.507f, 4.713f)
                curveTo(7.582f, 4.688f, 7.519f, 4.586f, 7.494f, 4.547f)
                lineTo(7.489f, 4.539f)
                curveTo(7.471f, 4.506f, 7.519f, 4.437f, 7.519f, 4.437f)
                curveTo(7.543f, 4.518f, 7.549f, 4.524f, 7.579f, 4.515f)
                curveTo(7.615f, 4.506f, 7.609f, 4.455f, 7.567f, 4.413f)
                curveTo(7.54f, 4.383f, 7.543f, 4.344f, 7.573f, 4.314f)
                curveTo(7.603f, 4.371f, 7.639f, 4.368f, 7.642f, 4.332f)
                lineTo(7.618f, 4.2f)
                horizontalLineTo(7.651f)
                lineTo(7.639f, 4.1f)
                horizontalLineTo(8.116f)
                lineTo(8.104f, 4.2f)
                horizontalLineTo(8.14f)
                lineTo(8.113f, 4.329f)
                curveTo(8.107f, 4.365f, 8.155f, 4.374f, 8.185f, 4.314f)
                curveTo(8.215f, 4.344f, 8.218f, 4.386f, 8.191f, 4.413f)
                curveTo(8.149f, 4.455f, 8.143f, 4.506f, 8.179f, 4.515f)
                curveTo(8.209f, 4.524f, 8.215f, 4.515f, 8.239f, 4.437f)
                curveTo(8.239f, 4.437f, 8.284f, 4.482f, 8.269f, 4.539f)
                lineTo(8.265f, 4.546f)
                curveTo(8.241f, 4.585f, 8.176f, 4.691f, 8.251f, 4.713f)
                curveTo(8.283f, 4.713f, 8.287f, 4.689f, 8.295f, 4.629f)
                lineTo(8.295f, 4.629f)
                lineTo(8.296f, 4.629f)
                curveTo(8.297f, 4.617f, 8.299f, 4.603f, 8.302f, 4.587f)
                curveTo(8.342f, 4.63f, 8.354f, 4.692f, 8.332f, 4.746f)
                curveTo(8.325f, 4.767f, 8.314f, 4.785f, 8.304f, 4.802f)
                curveTo(8.288f, 4.828f, 8.272f, 4.853f, 8.272f, 4.89f)
                curveTo(8.272f, 4.935f, 8.293f, 4.95f, 8.317f, 4.95f)
                curveTo(8.356f, 4.95f, 8.371f, 4.908f, 8.383f, 4.815f)
                curveTo(8.413f, 4.854f, 8.428f, 4.959f, 8.404f, 4.995f)
                lineTo(8.379f, 5.032f)
                curveTo(8.327f, 5.108f, 8.302f, 5.144f, 8.302f, 5.181f)
                curveTo(8.302f, 5.232f, 8.362f, 5.253f, 8.392f, 5.133f)
                curveTo(8.419f, 5.175f, 8.407f, 5.265f, 8.407f, 5.265f)
                curveTo(8.407f, 5.293f, 8.39f, 5.309f, 8.371f, 5.327f)
                curveTo(8.349f, 5.347f, 8.325f, 5.37f, 8.323f, 5.415f)
                verticalLineTo(5.52f)
                close()
                moveTo(5.167f, 5.52f)
                verticalLineTo(4.68f)
                curveTo(5.181f, 4.68f, 5.191f, 4.7f, 5.202f, 4.725f)
                curveTo(5.22f, 4.762f, 5.242f, 4.809f, 5.293f, 4.809f)
                curveTo(5.338f, 4.809f, 5.335f, 4.755f, 5.308f, 4.713f)
                curveTo(5.287f, 4.674f, 5.26f, 4.623f, 5.296f, 4.524f)
                curveTo(5.323f, 4.599f, 5.389f, 4.623f, 5.377f, 4.578f)
                curveTo(5.37f, 4.552f, 5.36f, 4.533f, 5.349f, 4.516f)
                curveTo(5.327f, 4.477f, 5.308f, 4.443f, 5.341f, 4.359f)
                curveTo(5.356f, 4.461f, 5.422f, 4.458f, 5.407f, 4.398f)
                curveTo(5.403f, 4.381f, 5.397f, 4.367f, 5.392f, 4.353f)
                curveTo(5.375f, 4.311f, 5.362f, 4.276f, 5.398f, 4.203f)
                curveTo(5.425f, 4.314f, 5.458f, 4.308f, 5.458f, 4.239f)
                curveTo(5.458f, 4.137f, 5.458f, 4.029f, 5.584f, 3.99f)
                curveTo(5.584f, 3.99f, 5.593f, 3.9f, 5.641f, 3.9f)
                curveTo(5.686f, 3.9f, 5.695f, 3.99f, 5.695f, 3.99f)
                curveTo(5.821f, 4.028f, 5.821f, 4.135f, 5.821f, 4.232f)
                lineTo(5.821f, 4.239f)
                curveTo(5.821f, 4.308f, 5.854f, 4.314f, 5.881f, 4.203f)
                curveTo(5.917f, 4.276f, 5.904f, 4.311f, 5.887f, 4.353f)
                curveTo(5.882f, 4.367f, 5.876f, 4.381f, 5.872f, 4.398f)
                curveTo(5.857f, 4.458f, 5.923f, 4.461f, 5.938f, 4.359f)
                curveTo(5.971f, 4.443f, 5.952f, 4.477f, 5.93f, 4.516f)
                curveTo(5.919f, 4.533f, 5.909f, 4.552f, 5.902f, 4.578f)
                curveTo(5.89f, 4.623f, 5.956f, 4.599f, 5.983f, 4.524f)
                curveTo(6.019f, 4.623f, 5.992f, 4.674f, 5.971f, 4.713f)
                curveTo(5.947f, 4.755f, 5.941f, 4.809f, 5.986f, 4.809f)
                curveTo(6.037f, 4.809f, 6.059f, 4.763f, 6.077f, 4.727f)
                curveTo(6.088f, 4.703f, 6.098f, 4.683f, 6.112f, 4.683f)
                verticalLineTo(5.52f)
                horizontalLineTo(5.167f)
                close()
                moveTo(7.81f, 4.093f)
                curveTo(7.81f, 4.093f, 7.807f, 3.97f, 7.879f, 3.967f)
                curveTo(7.948f, 3.967f, 7.945f, 4.093f, 7.945f, 4.093f)
                horizontalLineTo(7.81f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(5.167f, 5.55f)
                horizontalLineTo(5.152f)
                lineTo(5.167f, 5.565f)
                verticalLineTo(5.55f)
                close()
                moveTo(6.112f, 5.55f)
                verticalLineTo(5.565f)
                lineTo(6.127f, 5.55f)
                horizontalLineTo(6.112f)
                close()
                moveTo(7.435f, 5.58f)
                horizontalLineTo(7.42f)
                lineTo(7.435f, 5.595f)
                verticalLineTo(5.58f)
                close()
                moveTo(8.323f, 5.58f)
                verticalLineTo(5.595f)
                lineTo(8.338f, 5.58f)
                horizontalLineTo(8.323f)
                close()
                moveTo(9.649f, 5.55f)
                horizontalLineTo(9.634f)
                lineTo(9.649f, 5.565f)
                verticalLineTo(5.55f)
                close()
                moveTo(10.594f, 5.55f)
                verticalLineTo(5.565f)
                lineTo(10.609f, 5.55f)
                horizontalLineTo(10.594f)
                close()
                moveTo(10.704f, 5.52f)
                horizontalLineTo(10.719f)
                lineTo(10.704f, 5.505f)
                verticalLineTo(5.52f)
                close()
                moveTo(5.004f, 5.52f)
                verticalLineTo(5.505f)
                lineTo(4.989f, 5.52f)
                horizontalLineTo(5.004f)
                close()
                moveTo(4.702f, 6.826f)
                verticalLineTo(6.811f)
                lineTo(4.687f, 6.826f)
                horizontalLineTo(4.702f)
                close()
                moveTo(4.702f, 7.075f)
                horizontalLineTo(4.687f)
                lineTo(4.702f, 7.09f)
                verticalLineTo(7.075f)
                close()
                moveTo(5.392f, 7.075f)
                horizontalLineTo(5.407f)
                lineTo(5.392f, 7.06f)
                verticalLineTo(7.075f)
                close()
                moveTo(5.392f, 7.08f)
                verticalLineTo(7.095f)
                lineTo(5.407f, 7.08f)
                horizontalLineTo(5.392f)
                close()
                moveTo(4.396f, 7.08f)
                verticalLineTo(7.065f)
                lineTo(4.381f, 7.08f)
                horizontalLineTo(4.396f)
                close()
                moveTo(4.396f, 7.506f)
                horizontalLineTo(4.381f)
                lineTo(4.396f, 7.521f)
                verticalLineTo(7.506f)
                close()
                moveTo(5.392f, 7.506f)
                horizontalLineTo(5.407f)
                lineTo(5.392f, 7.491f)
                verticalLineTo(7.506f)
                close()
                moveTo(5.392f, 7.51f)
                verticalLineTo(7.525f)
                lineTo(5.407f, 7.51f)
                horizontalLineTo(5.392f)
                close()
                moveTo(4.201f, 7.51f)
                verticalLineTo(7.495f)
                lineTo(4.186f, 7.51f)
                horizontalLineTo(4.201f)
                close()
                moveTo(4.201f, 7.885f)
                horizontalLineTo(4.186f)
                lineTo(4.201f, 7.9f)
                verticalLineTo(7.885f)
                close()
                moveTo(11.56f, 7.885f)
                verticalLineTo(7.9f)
                lineTo(11.575f, 7.885f)
                horizontalLineTo(11.56f)
                close()
                moveTo(11.56f, 7.51f)
                horizontalLineTo(11.575f)
                lineTo(11.56f, 7.495f)
                verticalLineTo(7.51f)
                close()
                moveTo(10.366f, 7.51f)
                horizontalLineTo(10.351f)
                lineTo(10.366f, 7.525f)
                verticalLineTo(7.51f)
                close()
                moveTo(10.366f, 7.506f)
                verticalLineTo(7.491f)
                lineTo(10.351f, 7.506f)
                horizontalLineTo(10.366f)
                close()
                moveTo(11.368f, 7.506f)
                verticalLineTo(7.521f)
                lineTo(11.383f, 7.506f)
                horizontalLineTo(11.368f)
                close()
                moveTo(11.368f, 7.08f)
                horizontalLineTo(11.383f)
                lineTo(11.368f, 7.065f)
                verticalLineTo(7.08f)
                close()
                moveTo(10.366f, 7.08f)
                horizontalLineTo(10.351f)
                lineTo(10.366f, 7.095f)
                verticalLineTo(7.08f)
                close()
                moveTo(10.366f, 7.075f)
                verticalLineTo(7.06f)
                lineTo(10.351f, 7.075f)
                horizontalLineTo(10.366f)
                close()
                moveTo(11.062f, 7.075f)
                verticalLineTo(7.09f)
                lineTo(11.077f, 7.075f)
                horizontalLineTo(11.062f)
                close()
                moveTo(11.062f, 6.826f)
                horizontalLineTo(11.077f)
                lineTo(11.062f, 6.811f)
                verticalLineTo(6.826f)
                close()
                moveTo(10.704f, 6.834f)
                verticalLineTo(6.849f)
                lineTo(10.719f, 6.834f)
                horizontalLineTo(10.704f)
                close()
                moveTo(5.004f, 6.834f)
                horizontalLineTo(4.989f)
                lineTo(5.004f, 6.849f)
                verticalLineTo(6.834f)
                close()
                moveTo(10.594f, 4.68f)
                horizontalLineTo(10.609f)
                lineTo(10.594f, 4.665f)
                verticalLineTo(4.68f)
                close()
                moveTo(10.559f, 4.725f)
                lineTo(10.572f, 4.731f)
                verticalLineTo(4.731f)
                lineTo(10.559f, 4.725f)
                close()
                moveTo(10.453f, 4.713f)
                lineTo(10.466f, 4.721f)
                lineTo(10.466f, 4.72f)
                lineTo(10.453f, 4.713f)
                close()
                moveTo(10.465f, 4.524f)
                lineTo(10.479f, 4.519f)
                lineTo(10.451f, 4.519f)
                lineTo(10.465f, 4.524f)
                close()
                moveTo(10.384f, 4.578f)
                lineTo(10.399f, 4.582f)
                lineTo(10.399f, 4.582f)
                lineTo(10.384f, 4.578f)
                close()
                moveTo(10.412f, 4.516f)
                lineTo(10.399f, 4.508f)
                verticalLineTo(4.508f)
                lineTo(10.412f, 4.516f)
                close()
                moveTo(10.42f, 4.359f)
                lineTo(10.434f, 4.354f)
                lineTo(10.405f, 4.357f)
                lineTo(10.42f, 4.359f)
                close()
                moveTo(10.354f, 4.398f)
                lineTo(10.34f, 4.394f)
                lineTo(10.34f, 4.394f)
                lineTo(10.354f, 4.398f)
                close()
                moveTo(10.369f, 4.353f)
                lineTo(10.355f, 4.348f)
                verticalLineTo(4.348f)
                lineTo(10.369f, 4.353f)
                close()
                moveTo(10.363f, 4.203f)
                lineTo(10.377f, 4.196f)
                lineTo(10.349f, 4.199f)
                lineTo(10.363f, 4.203f)
                close()
                moveTo(10.177f, 3.99f)
                lineTo(10.162f, 3.991f)
                lineTo(10.173f, 4.004f)
                lineTo(10.177f, 3.99f)
                close()
                moveTo(10.066f, 3.99f)
                lineTo(10.07f, 4.004f)
                lineTo(10.081f, 3.991f)
                lineTo(10.066f, 3.99f)
                close()
                moveTo(9.94f, 4.232f)
                lineTo(9.955f, 4.232f)
                verticalLineTo(4.232f)
                lineTo(9.94f, 4.232f)
                close()
                moveTo(9.88f, 4.203f)
                lineTo(9.895f, 4.199f)
                lineTo(9.867f, 4.196f)
                lineTo(9.88f, 4.203f)
                close()
                moveTo(9.874f, 4.353f)
                lineTo(9.888f, 4.348f)
                verticalLineTo(4.348f)
                lineTo(9.874f, 4.353f)
                close()
                moveTo(9.889f, 4.398f)
                lineTo(9.904f, 4.394f)
                lineTo(9.904f, 4.394f)
                lineTo(9.889f, 4.398f)
                close()
                moveTo(9.823f, 4.359f)
                lineTo(9.838f, 4.357f)
                lineTo(9.809f, 4.354f)
                lineTo(9.823f, 4.359f)
                close()
                moveTo(9.831f, 4.516f)
                lineTo(9.844f, 4.508f)
                verticalLineTo(4.508f)
                lineTo(9.831f, 4.516f)
                close()
                moveTo(9.859f, 4.578f)
                lineTo(9.845f, 4.582f)
                lineTo(9.845f, 4.582f)
                lineTo(9.859f, 4.578f)
                close()
                moveTo(9.778f, 4.524f)
                lineTo(9.792f, 4.519f)
                lineTo(9.764f, 4.519f)
                lineTo(9.778f, 4.524f)
                close()
                moveTo(9.79f, 4.713f)
                lineTo(9.777f, 4.72f)
                lineTo(9.777f, 4.72f)
                lineTo(9.79f, 4.713f)
                close()
                moveTo(9.684f, 4.727f)
                lineTo(9.671f, 4.733f)
                verticalLineTo(4.733f)
                lineTo(9.684f, 4.727f)
                close()
                moveTo(9.649f, 4.683f)
                verticalLineTo(4.668f)
                lineTo(9.634f, 4.683f)
                horizontalLineTo(9.649f)
                close()
                moveTo(7.388f, 5.326f)
                lineTo(7.378f, 5.337f)
                lineTo(7.388f, 5.326f)
                close()
                moveTo(7.351f, 5.265f)
                horizontalLineTo(7.366f)
                lineTo(7.366f, 5.263f)
                lineTo(7.351f, 5.265f)
                close()
                moveTo(7.363f, 5.133f)
                lineTo(7.378f, 5.129f)
                lineTo(7.35f, 5.126f)
                lineTo(7.363f, 5.133f)
                close()
                moveTo(7.369f, 5.015f)
                lineTo(7.357f, 5.024f)
                lineTo(7.357f, 5.024f)
                lineTo(7.369f, 5.015f)
                close()
                moveTo(7.354f, 4.992f)
                lineTo(7.367f, 4.984f)
                lineTo(7.366f, 4.983f)
                lineTo(7.354f, 4.992f)
                close()
                moveTo(7.375f, 4.815f)
                lineTo(7.39f, 4.813f)
                lineTo(7.363f, 4.806f)
                lineTo(7.375f, 4.815f)
                close()
                moveTo(7.45f, 4.798f)
                lineTo(7.463f, 4.79f)
                verticalLineTo(4.79f)
                lineTo(7.45f, 4.798f)
                close()
                moveTo(7.423f, 4.746f)
                lineTo(7.409f, 4.751f)
                lineTo(7.409f, 4.751f)
                lineTo(7.423f, 4.746f)
                close()
                moveTo(7.456f, 4.587f)
                lineTo(7.471f, 4.585f)
                lineTo(7.445f, 4.576f)
                lineTo(7.456f, 4.587f)
                close()
                moveTo(7.463f, 4.629f)
                lineTo(7.448f, 4.632f)
                lineTo(7.448f, 4.632f)
                lineTo(7.463f, 4.629f)
                close()
                moveTo(7.463f, 4.629f)
                lineTo(7.477f, 4.627f)
                lineTo(7.477f, 4.627f)
                lineTo(7.463f, 4.629f)
                close()
                moveTo(7.507f, 4.713f)
                verticalLineTo(4.729f)
                lineTo(7.512f, 4.727f)
                lineTo(7.507f, 4.713f)
                close()
                moveTo(7.494f, 4.547f)
                lineTo(7.481f, 4.555f)
                lineTo(7.481f, 4.555f)
                lineTo(7.494f, 4.547f)
                close()
                moveTo(7.489f, 4.539f)
                lineTo(7.476f, 4.546f)
                lineTo(7.476f, 4.547f)
                lineTo(7.489f, 4.539f)
                close()
                moveTo(7.519f, 4.437f)
                lineTo(7.533f, 4.433f)
                lineTo(7.507f, 4.428f)
                lineTo(7.519f, 4.437f)
                close()
                moveTo(7.579f, 4.515f)
                lineTo(7.575f, 4.5f)
                lineTo(7.575f, 4.501f)
                lineTo(7.579f, 4.515f)
                close()
                moveTo(7.567f, 4.413f)
                lineTo(7.556f, 4.423f)
                lineTo(7.556f, 4.424f)
                lineTo(7.567f, 4.413f)
                close()
                moveTo(7.573f, 4.314f)
                lineTo(7.586f, 4.307f)
                lineTo(7.562f, 4.303f)
                lineTo(7.573f, 4.314f)
                close()
                moveTo(7.642f, 4.332f)
                lineTo(7.658f, 4.333f)
                lineTo(7.657f, 4.329f)
                lineTo(7.642f, 4.332f)
                close()
                moveTo(7.618f, 4.2f)
                verticalLineTo(4.185f)
                lineTo(7.603f, 4.203f)
                lineTo(7.618f, 4.2f)
                close()
                moveTo(7.651f, 4.2f)
                verticalLineTo(4.215f)
                lineTo(7.666f, 4.198f)
                lineTo(7.651f, 4.2f)
                close()
                moveTo(7.639f, 4.1f)
                verticalLineTo(4.085f)
                lineTo(7.624f, 4.102f)
                lineTo(7.639f, 4.1f)
                close()
                moveTo(8.116f, 4.1f)
                lineTo(8.131f, 4.102f)
                lineTo(8.116f, 4.085f)
                verticalLineTo(4.1f)
                close()
                moveTo(8.104f, 4.2f)
                lineTo(8.089f, 4.198f)
                lineTo(8.104f, 4.215f)
                verticalLineTo(4.2f)
                close()
                moveTo(8.14f, 4.2f)
                lineTo(8.155f, 4.203f)
                lineTo(8.14f, 4.185f)
                verticalLineTo(4.2f)
                close()
                moveTo(8.113f, 4.329f)
                lineTo(8.098f, 4.326f)
                lineTo(8.098f, 4.327f)
                lineTo(8.113f, 4.329f)
                close()
                moveTo(8.185f, 4.314f)
                lineTo(8.196f, 4.303f)
                lineTo(8.172f, 4.307f)
                lineTo(8.185f, 4.314f)
                close()
                moveTo(8.191f, 4.413f)
                lineTo(8.18f, 4.402f)
                verticalLineTo(4.402f)
                lineTo(8.191f, 4.413f)
                close()
                moveTo(8.179f, 4.515f)
                lineTo(8.183f, 4.501f)
                lineTo(8.183f, 4.5f)
                lineTo(8.179f, 4.515f)
                close()
                moveTo(8.239f, 4.437f)
                lineTo(8.25f, 4.426f)
                lineTo(8.225f, 4.433f)
                lineTo(8.239f, 4.437f)
                close()
                moveTo(8.269f, 4.539f)
                lineTo(8.282f, 4.547f)
                lineTo(8.284f, 4.543f)
                lineTo(8.269f, 4.539f)
                close()
                moveTo(8.265f, 4.546f)
                lineTo(8.277f, 4.554f)
                lineTo(8.277f, 4.554f)
                lineTo(8.265f, 4.546f)
                close()
                moveTo(8.251f, 4.713f)
                lineTo(8.247f, 4.728f)
                horizontalLineTo(8.251f)
                verticalLineTo(4.713f)
                close()
                moveTo(8.295f, 4.629f)
                lineTo(8.31f, 4.632f)
                lineTo(8.31f, 4.631f)
                lineTo(8.295f, 4.629f)
                close()
                moveTo(8.295f, 4.629f)
                lineTo(8.281f, 4.627f)
                lineTo(8.281f, 4.627f)
                lineTo(8.295f, 4.629f)
                close()
                moveTo(8.296f, 4.629f)
                lineTo(8.31f, 4.632f)
                lineTo(8.31f, 4.632f)
                lineTo(8.296f, 4.629f)
                close()
                moveTo(8.302f, 4.587f)
                lineTo(8.313f, 4.577f)
                lineTo(8.287f, 4.585f)
                lineTo(8.302f, 4.587f)
                close()
                moveTo(8.332f, 4.746f)
                lineTo(8.318f, 4.74f)
                lineTo(8.318f, 4.741f)
                lineTo(8.332f, 4.746f)
                close()
                moveTo(8.304f, 4.802f)
                lineTo(8.317f, 4.809f)
                verticalLineTo(4.809f)
                lineTo(8.304f, 4.802f)
                close()
                moveTo(8.383f, 4.815f)
                lineTo(8.395f, 4.806f)
                lineTo(8.368f, 4.813f)
                lineTo(8.383f, 4.815f)
                close()
                moveTo(8.404f, 4.995f)
                lineTo(8.416f, 5.003f)
                lineTo(8.417f, 5.003f)
                lineTo(8.404f, 4.995f)
                close()
                moveTo(8.379f, 5.032f)
                lineTo(8.391f, 5.041f)
                lineTo(8.391f, 5.041f)
                lineTo(8.379f, 5.032f)
                close()
                moveTo(8.392f, 5.133f)
                lineTo(8.405f, 5.125f)
                lineTo(8.377f, 5.129f)
                lineTo(8.392f, 5.133f)
                close()
                moveTo(8.407f, 5.265f)
                lineTo(8.392f, 5.263f)
                verticalLineTo(5.265f)
                horizontalLineTo(8.407f)
                close()
                moveTo(8.371f, 5.327f)
                lineTo(8.361f, 5.316f)
                verticalLineTo(5.316f)
                lineTo(8.371f, 5.327f)
                close()
                moveTo(8.323f, 5.415f)
                lineTo(8.308f, 5.414f)
                verticalLineTo(5.415f)
                horizontalLineTo(8.323f)
                close()
                moveTo(5.167f, 4.68f)
                verticalLineTo(4.665f)
                lineTo(5.152f, 4.68f)
                horizontalLineTo(5.167f)
                close()
                moveTo(5.202f, 4.725f)
                lineTo(5.216f, 4.718f)
                lineTo(5.216f, 4.718f)
                lineTo(5.202f, 4.725f)
                close()
                moveTo(5.308f, 4.713f)
                lineTo(5.295f, 4.72f)
                lineTo(5.295f, 4.721f)
                lineTo(5.308f, 4.713f)
                close()
                moveTo(5.296f, 4.524f)
                lineTo(5.31f, 4.519f)
                lineTo(5.282f, 4.519f)
                lineTo(5.296f, 4.524f)
                close()
                moveTo(5.377f, 4.578f)
                lineTo(5.363f, 4.582f)
                lineTo(5.363f, 4.582f)
                lineTo(5.377f, 4.578f)
                close()
                moveTo(5.349f, 4.516f)
                lineTo(5.362f, 4.508f)
                verticalLineTo(4.508f)
                lineTo(5.349f, 4.516f)
                close()
                moveTo(5.341f, 4.359f)
                lineTo(5.356f, 4.357f)
                lineTo(5.327f, 4.354f)
                lineTo(5.341f, 4.359f)
                close()
                moveTo(5.407f, 4.398f)
                lineTo(5.422f, 4.394f)
                lineTo(5.422f, 4.394f)
                lineTo(5.407f, 4.398f)
                close()
                moveTo(5.392f, 4.353f)
                lineTo(5.378f, 4.359f)
                verticalLineTo(4.359f)
                lineTo(5.392f, 4.353f)
                close()
                moveTo(5.398f, 4.203f)
                lineTo(5.413f, 4.199f)
                lineTo(5.385f, 4.196f)
                lineTo(5.398f, 4.203f)
                close()
                moveTo(5.584f, 3.99f)
                lineTo(5.588f, 4.004f)
                lineTo(5.599f, 3.991f)
                lineTo(5.584f, 3.99f)
                close()
                moveTo(5.695f, 3.99f)
                lineTo(5.68f, 3.991f)
                lineTo(5.691f, 4.004f)
                lineTo(5.695f, 3.99f)
                close()
                moveTo(5.821f, 4.232f)
                lineTo(5.806f, 4.232f)
                verticalLineTo(4.232f)
                lineTo(5.821f, 4.232f)
                close()
                moveTo(5.821f, 4.239f)
                lineTo(5.806f, 4.239f)
                verticalLineTo(4.239f)
                horizontalLineTo(5.821f)
                close()
                moveTo(5.881f, 4.203f)
                lineTo(5.894f, 4.196f)
                lineTo(5.866f, 4.199f)
                lineTo(5.881f, 4.203f)
                close()
                moveTo(5.887f, 4.353f)
                lineTo(5.901f, 4.359f)
                lineTo(5.887f, 4.353f)
                close()
                moveTo(5.872f, 4.398f)
                lineTo(5.858f, 4.394f)
                lineTo(5.858f, 4.394f)
                lineTo(5.872f, 4.398f)
                close()
                moveTo(5.938f, 4.359f)
                lineTo(5.952f, 4.354f)
                lineTo(5.923f, 4.357f)
                lineTo(5.938f, 4.359f)
                close()
                moveTo(5.93f, 4.516f)
                lineTo(5.917f, 4.508f)
                verticalLineTo(4.508f)
                lineTo(5.93f, 4.516f)
                close()
                moveTo(5.902f, 4.578f)
                lineTo(5.917f, 4.582f)
                lineTo(5.917f, 4.582f)
                lineTo(5.902f, 4.578f)
                close()
                moveTo(5.983f, 4.524f)
                lineTo(5.997f, 4.519f)
                lineTo(5.969f, 4.519f)
                lineTo(5.983f, 4.524f)
                close()
                moveTo(5.971f, 4.713f)
                lineTo(5.984f, 4.72f)
                lineTo(5.984f, 4.72f)
                lineTo(5.971f, 4.713f)
                close()
                moveTo(6.077f, 4.727f)
                lineTo(6.063f, 4.72f)
                lineTo(6.077f, 4.727f)
                close()
                moveTo(6.112f, 4.683f)
                horizontalLineTo(6.127f)
                lineTo(6.112f, 4.668f)
                verticalLineTo(4.683f)
                close()
                moveTo(7.879f, 3.967f)
                verticalLineTo(3.952f)
                lineTo(7.878f, 3.952f)
                lineTo(7.879f, 3.967f)
                close()
                moveTo(7.81f, 4.093f)
                lineTo(7.795f, 4.093f)
                lineTo(7.81f, 4.108f)
                verticalLineTo(4.093f)
                close()
                moveTo(7.945f, 4.093f)
                verticalLineTo(4.108f)
                lineTo(7.96f, 4.093f)
                lineTo(7.945f, 4.093f)
                close()
                moveTo(5.182f, 5.55f)
                verticalLineTo(5.52f)
                horizontalLineTo(5.152f)
                verticalLineTo(5.55f)
                horizontalLineTo(5.182f)
                close()
                moveTo(6.112f, 5.535f)
                horizontalLineTo(5.167f)
                verticalLineTo(5.565f)
                horizontalLineTo(6.112f)
                verticalLineTo(5.535f)
                close()
                moveTo(6.097f, 5.52f)
                verticalLineTo(5.55f)
                horizontalLineTo(6.127f)
                verticalLineTo(5.52f)
                horizontalLineTo(6.097f)
                close()
                moveTo(7.435f, 5.505f)
                horizontalLineTo(6.112f)
                verticalLineTo(5.535f)
                horizontalLineTo(7.435f)
                verticalLineTo(5.505f)
                close()
                moveTo(7.45f, 5.58f)
                verticalLineTo(5.52f)
                horizontalLineTo(7.42f)
                verticalLineTo(5.58f)
                horizontalLineTo(7.45f)
                close()
                moveTo(8.323f, 5.565f)
                horizontalLineTo(7.435f)
                verticalLineTo(5.595f)
                horizontalLineTo(8.323f)
                verticalLineTo(5.565f)
                close()
                moveTo(8.308f, 5.52f)
                verticalLineTo(5.58f)
                horizontalLineTo(8.338f)
                verticalLineTo(5.52f)
                horizontalLineTo(8.308f)
                close()
                moveTo(9.649f, 5.505f)
                horizontalLineTo(8.323f)
                verticalLineTo(5.535f)
                horizontalLineTo(9.649f)
                verticalLineTo(5.505f)
                close()
                moveTo(9.664f, 5.55f)
                verticalLineTo(5.52f)
                horizontalLineTo(9.634f)
                verticalLineTo(5.55f)
                horizontalLineTo(9.664f)
                close()
                moveTo(10.594f, 5.535f)
                horizontalLineTo(9.649f)
                verticalLineTo(5.565f)
                horizontalLineTo(10.594f)
                verticalLineTo(5.535f)
                close()
                moveTo(10.579f, 5.52f)
                verticalLineTo(5.55f)
                horizontalLineTo(10.609f)
                verticalLineTo(5.52f)
                horizontalLineTo(10.579f)
                close()
                moveTo(10.704f, 5.505f)
                horizontalLineTo(10.594f)
                verticalLineTo(5.535f)
                horizontalLineTo(10.704f)
                verticalLineTo(5.505f)
                close()
                moveTo(10.719f, 6.826f)
                verticalLineTo(5.52f)
                horizontalLineTo(10.689f)
                verticalLineTo(6.826f)
                horizontalLineTo(10.719f)
                close()
                moveTo(10.704f, 6.811f)
                horizontalLineTo(5.004f)
                verticalLineTo(6.841f)
                horizontalLineTo(10.704f)
                verticalLineTo(6.811f)
                close()
                moveTo(4.989f, 5.52f)
                verticalLineTo(6.826f)
                horizontalLineTo(5.019f)
                verticalLineTo(5.52f)
                horizontalLineTo(4.989f)
                close()
                moveTo(5.167f, 5.505f)
                horizontalLineTo(5.004f)
                verticalLineTo(5.535f)
                horizontalLineTo(5.167f)
                verticalLineTo(5.505f)
                close()
                moveTo(5.004f, 6.811f)
                horizontalLineTo(4.702f)
                verticalLineTo(6.841f)
                horizontalLineTo(5.004f)
                verticalLineTo(6.811f)
                close()
                moveTo(4.687f, 6.826f)
                verticalLineTo(7.075f)
                horizontalLineTo(4.717f)
                verticalLineTo(6.826f)
                horizontalLineTo(4.687f)
                close()
                moveTo(4.702f, 7.09f)
                horizontalLineTo(5.392f)
                verticalLineTo(7.06f)
                horizontalLineTo(4.702f)
                verticalLineTo(7.09f)
                close()
                moveTo(5.377f, 7.075f)
                verticalLineTo(7.08f)
                horizontalLineTo(5.407f)
                verticalLineTo(7.075f)
                horizontalLineTo(5.377f)
                close()
                moveTo(5.392f, 7.065f)
                horizontalLineTo(4.396f)
                verticalLineTo(7.095f)
                horizontalLineTo(5.392f)
                verticalLineTo(7.065f)
                close()
                moveTo(4.381f, 7.08f)
                verticalLineTo(7.506f)
                horizontalLineTo(4.411f)
                verticalLineTo(7.08f)
                horizontalLineTo(4.381f)
                close()
                moveTo(4.396f, 7.521f)
                horizontalLineTo(5.392f)
                verticalLineTo(7.491f)
                horizontalLineTo(4.396f)
                verticalLineTo(7.521f)
                close()
                moveTo(5.377f, 7.506f)
                verticalLineTo(7.51f)
                horizontalLineTo(5.407f)
                verticalLineTo(7.506f)
                horizontalLineTo(5.377f)
                close()
                moveTo(5.392f, 7.495f)
                horizontalLineTo(4.201f)
                verticalLineTo(7.525f)
                horizontalLineTo(5.392f)
                verticalLineTo(7.495f)
                close()
                moveTo(4.186f, 7.51f)
                verticalLineTo(7.885f)
                horizontalLineTo(4.216f)
                verticalLineTo(7.51f)
                horizontalLineTo(4.186f)
                close()
                moveTo(4.201f, 7.9f)
                horizontalLineTo(11.56f)
                verticalLineTo(7.87f)
                horizontalLineTo(4.201f)
                verticalLineTo(7.9f)
                close()
                moveTo(11.575f, 7.885f)
                verticalLineTo(7.51f)
                horizontalLineTo(11.545f)
                verticalLineTo(7.885f)
                horizontalLineTo(11.575f)
                close()
                moveTo(11.56f, 7.495f)
                horizontalLineTo(10.366f)
                verticalLineTo(7.525f)
                horizontalLineTo(11.56f)
                verticalLineTo(7.495f)
                close()
                moveTo(10.381f, 7.51f)
                verticalLineTo(7.506f)
                horizontalLineTo(10.351f)
                verticalLineTo(7.51f)
                horizontalLineTo(10.381f)
                close()
                moveTo(10.366f, 7.521f)
                horizontalLineTo(11.368f)
                verticalLineTo(7.491f)
                horizontalLineTo(10.366f)
                verticalLineTo(7.521f)
                close()
                moveTo(11.383f, 7.506f)
                verticalLineTo(7.08f)
                horizontalLineTo(11.353f)
                verticalLineTo(7.506f)
                horizontalLineTo(11.383f)
                close()
                moveTo(11.368f, 7.065f)
                horizontalLineTo(10.366f)
                verticalLineTo(7.095f)
                horizontalLineTo(11.368f)
                verticalLineTo(7.065f)
                close()
                moveTo(10.381f, 7.08f)
                verticalLineTo(7.075f)
                horizontalLineTo(10.351f)
                verticalLineTo(7.08f)
                horizontalLineTo(10.381f)
                close()
                moveTo(10.366f, 7.09f)
                horizontalLineTo(11.062f)
                verticalLineTo(7.06f)
                horizontalLineTo(10.366f)
                verticalLineTo(7.09f)
                close()
                moveTo(11.077f, 7.075f)
                verticalLineTo(6.826f)
                horizontalLineTo(11.047f)
                verticalLineTo(7.075f)
                horizontalLineTo(11.077f)
                close()
                moveTo(11.062f, 6.811f)
                horizontalLineTo(10.704f)
                verticalLineTo(6.841f)
                horizontalLineTo(11.062f)
                verticalLineTo(6.811f)
                close()
                moveTo(10.719f, 6.834f)
                verticalLineTo(6.826f)
                horizontalLineTo(10.689f)
                verticalLineTo(6.834f)
                horizontalLineTo(10.719f)
                close()
                moveTo(5.004f, 6.849f)
                horizontalLineTo(10.704f)
                verticalLineTo(6.819f)
                horizontalLineTo(5.004f)
                verticalLineTo(6.849f)
                close()
                moveTo(4.989f, 6.826f)
                verticalLineTo(6.834f)
                horizontalLineTo(5.019f)
                verticalLineTo(6.826f)
                horizontalLineTo(4.989f)
                close()
                moveTo(10.579f, 4.68f)
                verticalLineTo(5.52f)
                horizontalLineTo(10.609f)
                verticalLineTo(4.68f)
                horizontalLineTo(10.579f)
                close()
                moveTo(10.572f, 4.731f)
                curveTo(10.578f, 4.718f, 10.583f, 4.709f, 10.588f, 4.702f)
                curveTo(10.59f, 4.698f, 10.592f, 4.697f, 10.593f, 4.696f)
                curveTo(10.594f, 4.695f, 10.594f, 4.695f, 10.594f, 4.695f)
                curveTo(10.594f, 4.695f, 10.594f, 4.695f, 10.594f, 4.695f)
                curveTo(10.594f, 4.695f, 10.594f, 4.695f, 10.594f, 4.695f)
                curveTo(10.594f, 4.695f, 10.594f, 4.695f, 10.594f, 4.695f)
                verticalLineTo(4.665f)
                curveTo(10.579f, 4.665f, 10.569f, 4.676f, 10.563f, 4.685f)
                curveTo(10.557f, 4.694f, 10.551f, 4.706f, 10.545f, 4.718f)
                lineTo(10.572f, 4.731f)
                close()
                moveTo(10.468f, 4.824f)
                curveTo(10.499f, 4.824f, 10.521f, 4.809f, 10.537f, 4.791f)
                curveTo(10.553f, 4.772f, 10.564f, 4.749f, 10.572f, 4.731f)
                lineTo(10.545f, 4.718f)
                curveTo(10.536f, 4.737f, 10.527f, 4.756f, 10.514f, 4.771f)
                curveTo(10.502f, 4.785f, 10.488f, 4.794f, 10.468f, 4.794f)
                verticalLineTo(4.824f)
                close()
                moveTo(10.44f, 4.705f)
                curveTo(10.426f, 4.728f, 10.417f, 4.755f, 10.419f, 4.778f)
                curveTo(10.42f, 4.79f, 10.423f, 4.801f, 10.432f, 4.81f)
                curveTo(10.441f, 4.82f, 10.454f, 4.824f, 10.468f, 4.824f)
                verticalLineTo(4.794f)
                curveTo(10.46f, 4.794f, 10.456f, 4.792f, 10.454f, 4.789f)
                curveTo(10.451f, 4.787f, 10.449f, 4.783f, 10.448f, 4.776f)
                curveTo(10.447f, 4.761f, 10.453f, 4.74f, 10.466f, 4.721f)
                lineTo(10.44f, 4.705f)
                close()
                moveTo(10.451f, 4.529f)
                curveTo(10.468f, 4.577f, 10.47f, 4.612f, 10.466f, 4.639f)
                curveTo(10.461f, 4.666f, 10.45f, 4.686f, 10.44f, 4.706f)
                lineTo(10.466f, 4.72f)
                curveTo(10.477f, 4.701f, 10.49f, 4.676f, 10.495f, 4.643f)
                curveTo(10.501f, 4.61f, 10.498f, 4.57f, 10.479f, 4.519f)
                lineTo(10.451f, 4.529f)
                close()
                moveTo(10.37f, 4.574f)
                curveTo(10.366f, 4.587f, 10.366f, 4.604f, 10.38f, 4.612f)
                curveTo(10.387f, 4.616f, 10.394f, 4.616f, 10.399f, 4.615f)
                curveTo(10.405f, 4.614f, 10.411f, 4.612f, 10.417f, 4.609f)
                curveTo(10.439f, 4.597f, 10.465f, 4.569f, 10.479f, 4.529f)
                lineTo(10.451f, 4.519f)
                curveTo(10.438f, 4.554f, 10.417f, 4.575f, 10.403f, 4.583f)
                curveTo(10.399f, 4.585f, 10.397f, 4.585f, 10.395f, 4.586f)
                curveTo(10.394f, 4.586f, 10.394f, 4.585f, 10.396f, 4.586f)
                curveTo(10.4f, 4.589f, 10.396f, 4.592f, 10.399f, 4.582f)
                lineTo(10.37f, 4.574f)
                close()
                moveTo(10.399f, 4.508f)
                curveTo(10.389f, 4.526f, 10.377f, 4.547f, 10.37f, 4.574f)
                lineTo(10.399f, 4.582f)
                curveTo(10.405f, 4.558f, 10.415f, 4.541f, 10.425f, 4.523f)
                lineTo(10.399f, 4.508f)
                close()
                moveTo(10.406f, 4.364f)
                curveTo(10.422f, 4.405f, 10.425f, 4.432f, 10.422f, 4.452f)
                curveTo(10.419f, 4.473f, 10.41f, 4.489f, 10.399f, 4.508f)
                lineTo(10.425f, 4.523f)
                curveTo(10.436f, 4.504f, 10.447f, 4.483f, 10.451f, 4.456f)
                curveTo(10.455f, 4.429f, 10.451f, 4.397f, 10.434f, 4.354f)
                lineTo(10.406f, 4.364f)
                close()
                moveTo(10.34f, 4.394f)
                curveTo(10.335f, 4.411f, 10.336f, 4.427f, 10.343f, 4.439f)
                curveTo(10.347f, 4.445f, 10.352f, 4.45f, 10.359f, 4.453f)
                curveTo(10.366f, 4.456f, 10.373f, 4.456f, 10.38f, 4.454f)
                curveTo(10.393f, 4.45f, 10.405f, 4.439f, 10.414f, 4.424f)
                curveTo(10.424f, 4.409f, 10.431f, 4.388f, 10.435f, 4.361f)
                lineTo(10.405f, 4.357f)
                curveTo(10.402f, 4.381f, 10.395f, 4.398f, 10.389f, 4.409f)
                curveTo(10.382f, 4.42f, 10.375f, 4.424f, 10.372f, 4.425f)
                curveTo(10.37f, 4.425f, 10.37f, 4.425f, 10.37f, 4.425f)
                curveTo(10.37f, 4.425f, 10.37f, 4.425f, 10.37f, 4.425f)
                curveTo(10.369f, 4.425f, 10.369f, 4.424f, 10.369f, 4.424f)
                curveTo(10.367f, 4.421f, 10.365f, 4.415f, 10.369f, 4.402f)
                lineTo(10.34f, 4.394f)
                close()
                moveTo(10.355f, 4.348f)
                curveTo(10.35f, 4.361f, 10.344f, 4.377f, 10.34f, 4.394f)
                lineTo(10.369f, 4.402f)
                curveTo(10.373f, 4.386f, 10.378f, 4.372f, 10.383f, 4.359f)
                lineTo(10.355f, 4.348f)
                close()
                moveTo(10.35f, 4.21f)
                curveTo(10.367f, 4.245f, 10.372f, 4.269f, 10.371f, 4.289f)
                curveTo(10.37f, 4.309f, 10.364f, 4.326f, 10.355f, 4.348f)
                lineTo(10.383f, 4.359f)
                curveTo(10.392f, 4.338f, 10.4f, 4.316f, 10.401f, 4.29f)
                curveTo(10.402f, 4.264f, 10.395f, 4.234f, 10.377f, 4.196f)
                lineTo(10.35f, 4.21f)
                close()
                moveTo(10.288f, 4.239f)
                curveTo(10.288f, 4.257f, 10.29f, 4.273f, 10.295f, 4.284f)
                curveTo(10.297f, 4.289f, 10.3f, 4.295f, 10.306f, 4.299f)
                curveTo(10.312f, 4.304f, 10.32f, 4.305f, 10.328f, 4.303f)
                curveTo(10.334f, 4.301f, 10.34f, 4.296f, 10.344f, 4.291f)
                curveTo(10.348f, 4.286f, 10.352f, 4.279f, 10.356f, 4.272f)
                curveTo(10.363f, 4.256f, 10.371f, 4.235f, 10.378f, 4.207f)
                lineTo(10.349f, 4.199f)
                curveTo(10.342f, 4.227f, 10.335f, 4.246f, 10.329f, 4.259f)
                curveTo(10.326f, 4.265f, 10.323f, 4.269f, 10.321f, 4.272f)
                curveTo(10.318f, 4.274f, 10.318f, 4.274f, 10.318f, 4.274f)
                curveTo(10.32f, 4.274f, 10.322f, 4.274f, 10.324f, 4.275f)
                curveTo(10.325f, 4.276f, 10.324f, 4.275f, 10.323f, 4.272f)
                curveTo(10.32f, 4.266f, 10.318f, 4.255f, 10.318f, 4.239f)
                horizontalLineTo(10.288f)
                close()
                moveTo(10.173f, 4.004f)
                curveTo(10.231f, 4.022f, 10.259f, 4.056f, 10.273f, 4.096f)
                curveTo(10.288f, 4.138f, 10.288f, 4.187f, 10.288f, 4.239f)
                horizontalLineTo(10.318f)
                curveTo(10.318f, 4.189f, 10.318f, 4.133f, 10.301f, 4.086f)
                curveTo(10.284f, 4.037f, 10.249f, 3.997f, 10.182f, 3.976f)
                lineTo(10.173f, 4.004f)
                close()
                moveTo(10.12f, 3.915f)
                curveTo(10.127f, 3.915f, 10.132f, 3.918f, 10.138f, 3.924f)
                curveTo(10.144f, 3.931f, 10.149f, 3.94f, 10.153f, 3.95f)
                curveTo(10.156f, 3.96f, 10.159f, 3.971f, 10.16f, 3.979f)
                curveTo(10.161f, 3.983f, 10.161f, 3.986f, 10.162f, 3.988f)
                curveTo(10.162f, 3.989f, 10.162f, 3.99f, 10.162f, 3.991f)
                curveTo(10.162f, 3.991f, 10.162f, 3.991f, 10.162f, 3.991f)
                curveTo(10.162f, 3.991f, 10.162f, 3.991f, 10.162f, 3.991f)
                curveTo(10.162f, 3.991f, 10.162f, 3.992f, 10.162f, 3.992f)
                curveTo(10.162f, 3.992f, 10.162f, 3.992f, 10.162f, 3.992f)
                curveTo(10.162f, 3.991f, 10.162f, 3.991f, 10.162f, 3.991f)
                curveTo(10.162f, 3.991f, 10.162f, 3.991f, 10.177f, 3.99f)
                curveTo(10.192f, 3.989f, 10.192f, 3.989f, 10.192f, 3.989f)
                curveTo(10.192f, 3.989f, 10.192f, 3.988f, 10.192f, 3.988f)
                curveTo(10.192f, 3.988f, 10.192f, 3.988f, 10.192f, 3.988f)
                curveTo(10.192f, 3.988f, 10.192f, 3.988f, 10.192f, 3.988f)
                curveTo(10.192f, 3.988f, 10.192f, 3.988f, 10.192f, 3.988f)
                curveTo(10.192f, 3.988f, 10.192f, 3.988f, 10.192f, 3.987f)
                curveTo(10.192f, 3.986f, 10.192f, 3.985f, 10.191f, 3.984f)
                curveTo(10.191f, 3.981f, 10.191f, 3.978f, 10.19f, 3.973f)
                curveTo(10.188f, 3.964f, 10.185f, 3.952f, 10.181f, 3.94f)
                curveTo(10.176f, 3.928f, 10.17f, 3.914f, 10.16f, 3.904f)
                curveTo(10.151f, 3.893f, 10.137f, 3.885f, 10.12f, 3.885f)
                verticalLineTo(3.915f)
                close()
                moveTo(10.066f, 3.99f)
                curveTo(10.081f, 3.991f, 10.081f, 3.991f, 10.081f, 3.991f)
                curveTo(10.081f, 3.991f, 10.081f, 3.991f, 10.081f, 3.991f)
                curveTo(10.081f, 3.992f, 10.081f, 3.992f, 10.081f, 3.992f)
                curveTo(10.081f, 3.992f, 10.081f, 3.991f, 10.081f, 3.991f)
                curveTo(10.081f, 3.991f, 10.081f, 3.991f, 10.081f, 3.991f)
                curveTo(10.081f, 3.991f, 10.081f, 3.991f, 10.081f, 3.991f)
                curveTo(10.081f, 3.99f, 10.081f, 3.989f, 10.081f, 3.988f)
                curveTo(10.082f, 3.986f, 10.082f, 3.983f, 10.083f, 3.979f)
                curveTo(10.084f, 3.971f, 10.087f, 3.96f, 10.09f, 3.95f)
                curveTo(10.094f, 3.94f, 10.099f, 3.93f, 10.104f, 3.924f)
                curveTo(10.109f, 3.918f, 10.115f, 3.915f, 10.12f, 3.915f)
                verticalLineTo(3.885f)
                curveTo(10.103f, 3.885f, 10.09f, 3.894f, 10.081f, 3.904f)
                curveTo(10.072f, 3.915f, 10.066f, 3.928f, 10.062f, 3.94f)
                curveTo(10.058f, 3.952f, 10.055f, 3.964f, 10.053f, 3.973f)
                curveTo(10.053f, 3.978f, 10.052f, 3.981f, 10.052f, 3.984f)
                curveTo(10.052f, 3.985f, 10.051f, 3.987f, 10.051f, 3.987f)
                curveTo(10.051f, 3.988f, 10.051f, 3.988f, 10.051f, 3.988f)
                curveTo(10.051f, 3.988f, 10.051f, 3.988f, 10.051f, 3.988f)
                curveTo(10.051f, 3.988f, 10.051f, 3.988f, 10.051f, 3.988f)
                curveTo(10.051f, 3.988f, 10.051f, 3.988f, 10.051f, 3.988f)
                curveTo(10.051f, 3.988f, 10.051f, 3.989f, 10.051f, 3.989f)
                curveTo(10.051f, 3.989f, 10.051f, 3.989f, 10.066f, 3.99f)
                close()
                moveTo(9.955f, 4.232f)
                curveTo(9.955f, 4.183f, 9.955f, 4.135f, 9.97f, 4.094f)
                curveTo(9.984f, 4.055f, 10.012f, 4.022f, 10.07f, 4.004f)
                lineTo(10.062f, 3.976f)
                curveTo(9.994f, 3.996f, 9.959f, 4.036f, 9.942f, 4.084f)
                curveTo(9.925f, 4.131f, 9.925f, 4.184f, 9.925f, 4.232f)
                lineTo(9.955f, 4.232f)
                close()
                moveTo(9.955f, 4.239f)
                curveTo(9.955f, 4.237f, 9.955f, 4.235f, 9.955f, 4.232f)
                lineTo(9.925f, 4.232f)
                curveTo(9.925f, 4.235f, 9.925f, 4.237f, 9.925f, 4.239f)
                horizontalLineTo(9.955f)
                close()
                moveTo(9.865f, 4.207f)
                curveTo(9.872f, 4.235f, 9.88f, 4.256f, 9.887f, 4.272f)
                curveTo(9.891f, 4.279f, 9.895f, 4.286f, 9.899f, 4.291f)
                curveTo(9.904f, 4.296f, 9.909f, 4.301f, 9.916f, 4.303f)
                curveTo(9.923f, 4.305f, 9.931f, 4.304f, 9.937f, 4.299f)
                curveTo(9.943f, 4.295f, 9.946f, 4.289f, 9.948f, 4.284f)
                curveTo(9.953f, 4.273f, 9.955f, 4.257f, 9.955f, 4.239f)
                horizontalLineTo(9.925f)
                curveTo(9.925f, 4.255f, 9.923f, 4.266f, 9.921f, 4.272f)
                curveTo(9.919f, 4.275f, 9.919f, 4.276f, 9.919f, 4.275f)
                curveTo(9.921f, 4.274f, 9.923f, 4.274f, 9.925f, 4.274f)
                curveTo(9.926f, 4.274f, 9.925f, 4.274f, 9.922f, 4.272f)
                curveTo(9.92f, 4.269f, 9.917f, 4.265f, 9.914f, 4.259f)
                curveTo(9.908f, 4.246f, 9.901f, 4.227f, 9.895f, 4.199f)
                lineTo(9.865f, 4.207f)
                close()
                moveTo(9.888f, 4.348f)
                curveTo(9.879f, 4.326f, 9.873f, 4.309f, 9.872f, 4.289f)
                curveTo(9.871f, 4.269f, 9.876f, 4.245f, 9.893f, 4.21f)
                lineTo(9.867f, 4.196f)
                curveTo(9.848f, 4.234f, 9.841f, 4.264f, 9.842f, 4.29f)
                curveTo(9.843f, 4.316f, 9.852f, 4.338f, 9.86f, 4.359f)
                lineTo(9.888f, 4.348f)
                close()
                moveTo(9.904f, 4.394f)
                curveTo(9.899f, 4.377f, 9.893f, 4.361f, 9.888f, 4.348f)
                lineTo(9.86f, 4.359f)
                curveTo(9.865f, 4.372f, 9.87f, 4.386f, 9.875f, 4.402f)
                lineTo(9.904f, 4.394f)
                close()
                moveTo(9.808f, 4.361f)
                curveTo(9.812f, 4.388f, 9.82f, 4.409f, 9.829f, 4.424f)
                curveTo(9.838f, 4.439f, 9.85f, 4.45f, 9.863f, 4.454f)
                curveTo(9.87f, 4.456f, 9.877f, 4.456f, 9.884f, 4.453f)
                curveTo(9.891f, 4.45f, 9.896f, 4.445f, 9.9f, 4.439f)
                curveTo(9.907f, 4.427f, 9.908f, 4.411f, 9.904f, 4.394f)
                lineTo(9.875f, 4.402f)
                curveTo(9.878f, 4.415f, 9.876f, 4.421f, 9.874f, 4.424f)
                curveTo(9.874f, 4.424f, 9.874f, 4.425f, 9.874f, 4.425f)
                curveTo(9.873f, 4.425f, 9.873f, 4.425f, 9.873f, 4.425f)
                curveTo(9.873f, 4.425f, 9.873f, 4.425f, 9.871f, 4.425f)
                curveTo(9.868f, 4.424f, 9.861f, 4.42f, 9.855f, 4.409f)
                curveTo(9.848f, 4.398f, 9.841f, 4.381f, 9.838f, 4.357f)
                lineTo(9.808f, 4.361f)
                close()
                moveTo(9.844f, 4.508f)
                curveTo(9.833f, 4.489f, 9.824f, 4.473f, 9.821f, 4.452f)
                curveTo(9.819f, 4.432f, 9.821f, 4.405f, 9.837f, 4.364f)
                lineTo(9.809f, 4.354f)
                curveTo(9.792f, 4.397f, 9.788f, 4.429f, 9.792f, 4.456f)
                curveTo(9.796f, 4.483f, 9.807f, 4.504f, 9.818f, 4.523f)
                lineTo(9.844f, 4.508f)
                close()
                moveTo(9.874f, 4.574f)
                curveTo(9.866f, 4.547f, 9.855f, 4.526f, 9.844f, 4.508f)
                lineTo(9.818f, 4.523f)
                curveTo(9.829f, 4.541f, 9.838f, 4.558f, 9.845f, 4.582f)
                lineTo(9.874f, 4.574f)
                close()
                moveTo(9.764f, 4.529f)
                curveTo(9.778f, 4.569f, 9.804f, 4.597f, 9.826f, 4.609f)
                curveTo(9.832f, 4.612f, 9.838f, 4.614f, 9.844f, 4.615f)
                curveTo(9.85f, 4.616f, 9.857f, 4.616f, 9.863f, 4.612f)
                curveTo(9.877f, 4.604f, 9.877f, 4.587f, 9.874f, 4.574f)
                lineTo(9.845f, 4.582f)
                curveTo(9.847f, 4.592f, 9.843f, 4.589f, 9.848f, 4.586f)
                curveTo(9.849f, 4.585f, 9.85f, 4.586f, 9.848f, 4.586f)
                curveTo(9.846f, 4.585f, 9.844f, 4.585f, 9.84f, 4.583f)
                curveTo(9.826f, 4.575f, 9.805f, 4.554f, 9.792f, 4.519f)
                lineTo(9.764f, 4.529f)
                close()
                moveTo(9.803f, 4.706f)
                curveTo(9.793f, 4.686f, 9.782f, 4.666f, 9.777f, 4.639f)
                curveTo(9.773f, 4.612f, 9.775f, 4.577f, 9.792f, 4.529f)
                lineTo(9.764f, 4.519f)
                curveTo(9.745f, 4.57f, 9.743f, 4.61f, 9.748f, 4.643f)
                curveTo(9.753f, 4.676f, 9.766f, 4.701f, 9.777f, 4.72f)
                lineTo(9.803f, 4.706f)
                close()
                moveTo(9.775f, 4.824f)
                curveTo(9.789f, 4.824f, 9.802f, 4.82f, 9.811f, 4.81f)
                curveTo(9.819f, 4.801f, 9.823f, 4.789f, 9.823f, 4.778f)
                curveTo(9.825f, 4.755f, 9.816f, 4.728f, 9.803f, 4.706f)
                lineTo(9.777f, 4.72f)
                curveTo(9.788f, 4.74f, 9.794f, 4.761f, 9.793f, 4.776f)
                curveTo(9.793f, 4.783f, 9.791f, 4.787f, 9.789f, 4.79f)
                curveTo(9.787f, 4.792f, 9.783f, 4.794f, 9.775f, 4.794f)
                verticalLineTo(4.824f)
                close()
                moveTo(9.671f, 4.733f)
                curveTo(9.68f, 4.751f, 9.69f, 4.773f, 9.706f, 4.791f)
                curveTo(9.722f, 4.81f, 9.744f, 4.824f, 9.775f, 4.824f)
                verticalLineTo(4.794f)
                curveTo(9.755f, 4.794f, 9.741f, 4.785f, 9.729f, 4.772f)
                curveTo(9.716f, 4.757f, 9.707f, 4.739f, 9.698f, 4.72f)
                lineTo(9.671f, 4.733f)
                close()
                moveTo(9.649f, 4.698f)
                curveTo(9.649f, 4.698f, 9.649f, 4.698f, 9.649f, 4.698f)
                curveTo(9.649f, 4.698f, 9.65f, 4.698f, 9.65f, 4.699f)
                curveTo(9.651f, 4.7f, 9.653f, 4.701f, 9.655f, 4.705f)
                curveTo(9.66f, 4.711f, 9.665f, 4.721f, 9.671f, 4.733f)
                lineTo(9.698f, 4.72f)
                curveTo(9.692f, 4.708f, 9.686f, 4.696f, 9.68f, 4.687f)
                curveTo(9.674f, 4.678f, 9.664f, 4.668f, 9.649f, 4.668f)
                verticalLineTo(4.698f)
                close()
                moveTo(9.664f, 5.52f)
                verticalLineTo(4.683f)
                horizontalLineTo(9.634f)
                verticalLineTo(5.52f)
                horizontalLineTo(9.664f)
                close()
                moveTo(10.594f, 5.505f)
                horizontalLineTo(9.649f)
                verticalLineTo(5.535f)
                horizontalLineTo(10.594f)
                verticalLineTo(5.505f)
                close()
                moveTo(7.435f, 5.535f)
                horizontalLineTo(8.323f)
                verticalLineTo(5.505f)
                horizontalLineTo(7.435f)
                verticalLineTo(5.535f)
                close()
                moveTo(7.42f, 5.415f)
                verticalLineTo(5.52f)
                horizontalLineTo(7.45f)
                verticalLineTo(5.415f)
                horizontalLineTo(7.42f)
                close()
                moveTo(7.378f, 5.337f)
                curveTo(7.4f, 5.358f, 7.42f, 5.377f, 7.42f, 5.415f)
                horizontalLineTo(7.45f)
                curveTo(7.45f, 5.362f, 7.421f, 5.336f, 7.398f, 5.315f)
                lineTo(7.378f, 5.337f)
                close()
                moveTo(7.336f, 5.265f)
                curveTo(7.336f, 5.3f, 7.359f, 5.32f, 7.378f, 5.337f)
                lineTo(7.398f, 5.315f)
                curveTo(7.378f, 5.297f, 7.366f, 5.285f, 7.366f, 5.265f)
                horizontalLineTo(7.336f)
                close()
                moveTo(7.35f, 5.126f)
                curveTo(7.343f, 5.138f, 7.339f, 5.154f, 7.336f, 5.169f)
                curveTo(7.334f, 5.184f, 7.333f, 5.2f, 7.333f, 5.215f)
                curveTo(7.333f, 5.229f, 7.334f, 5.242f, 7.335f, 5.252f)
                curveTo(7.335f, 5.256f, 7.335f, 5.26f, 7.336f, 5.263f)
                curveTo(7.336f, 5.264f, 7.336f, 5.265f, 7.336f, 5.266f)
                curveTo(7.336f, 5.266f, 7.336f, 5.266f, 7.336f, 5.267f)
                curveTo(7.336f, 5.267f, 7.336f, 5.267f, 7.336f, 5.267f)
                curveTo(7.336f, 5.267f, 7.336f, 5.267f, 7.336f, 5.267f)
                curveTo(7.336f, 5.267f, 7.336f, 5.267f, 7.336f, 5.267f)
                curveTo(7.336f, 5.267f, 7.336f, 5.267f, 7.336f, 5.267f)
                curveTo(7.336f, 5.267f, 7.336f, 5.267f, 7.351f, 5.265f)
                curveTo(7.366f, 5.263f, 7.366f, 5.263f, 7.366f, 5.263f)
                curveTo(7.366f, 5.263f, 7.366f, 5.263f, 7.366f, 5.263f)
                curveTo(7.366f, 5.263f, 7.366f, 5.263f, 7.366f, 5.263f)
                curveTo(7.366f, 5.263f, 7.366f, 5.263f, 7.366f, 5.263f)
                curveTo(7.366f, 5.263f, 7.366f, 5.263f, 7.366f, 5.263f)
                curveTo(7.366f, 5.263f, 7.366f, 5.262f, 7.366f, 5.262f)
                curveTo(7.366f, 5.262f, 7.366f, 5.261f, 7.365f, 5.259f)
                curveTo(7.365f, 5.257f, 7.365f, 5.253f, 7.365f, 5.249f)
                curveTo(7.364f, 5.24f, 7.363f, 5.228f, 7.363f, 5.215f)
                curveTo(7.363f, 5.201f, 7.364f, 5.187f, 7.366f, 5.174f)
                curveTo(7.368f, 5.16f, 7.371f, 5.149f, 7.376f, 5.14f)
                lineTo(7.35f, 5.126f)
                close()
                moveTo(7.438f, 5.181f)
                curveTo(7.438f, 5.191f, 7.435f, 5.198f, 7.432f, 5.202f)
                curveTo(7.429f, 5.206f, 7.426f, 5.207f, 7.423f, 5.206f)
                curveTo(7.419f, 5.206f, 7.412f, 5.202f, 7.403f, 5.19f)
                curveTo(7.395f, 5.177f, 7.385f, 5.158f, 7.378f, 5.129f)
                lineTo(7.349f, 5.137f)
                curveTo(7.357f, 5.168f, 7.367f, 5.191f, 7.379f, 5.207f)
                curveTo(7.39f, 5.223f, 7.403f, 5.233f, 7.418f, 5.236f)
                curveTo(7.433f, 5.239f, 7.447f, 5.232f, 7.455f, 5.221f)
                curveTo(7.464f, 5.211f, 7.468f, 5.196f, 7.468f, 5.181f)
                horizontalLineTo(7.438f)
                close()
                moveTo(7.357f, 5.024f)
                curveTo(7.386f, 5.068f, 7.407f, 5.099f, 7.42f, 5.124f)
                curveTo(7.433f, 5.148f, 7.438f, 5.165f, 7.438f, 5.181f)
                horizontalLineTo(7.468f)
                curveTo(7.468f, 5.158f, 7.46f, 5.136f, 7.446f, 5.11f)
                curveTo(7.432f, 5.083f, 7.411f, 5.051f, 7.382f, 5.007f)
                lineTo(7.357f, 5.024f)
                close()
                moveTo(7.342f, 5f)
                lineTo(7.357f, 5.024f)
                lineTo(7.382f, 5.007f)
                lineTo(7.367f, 4.984f)
                lineTo(7.342f, 5f)
                close()
                moveTo(7.363f, 4.806f)
                curveTo(7.346f, 4.828f, 7.334f, 4.868f, 7.329f, 4.904f)
                curveTo(7.327f, 4.922f, 7.326f, 4.941f, 7.328f, 4.957f)
                curveTo(7.33f, 4.973f, 7.334f, 4.989f, 7.342f, 5.001f)
                lineTo(7.366f, 4.983f)
                curveTo(7.363f, 4.978f, 7.359f, 4.969f, 7.358f, 4.954f)
                curveTo(7.357f, 4.941f, 7.357f, 4.924f, 7.359f, 4.908f)
                curveTo(7.364f, 4.873f, 7.374f, 4.841f, 7.387f, 4.824f)
                lineTo(7.363f, 4.806f)
                close()
                moveTo(7.441f, 4.935f)
                curveTo(7.434f, 4.935f, 7.43f, 4.933f, 7.425f, 4.93f)
                curveTo(7.421f, 4.926f, 7.416f, 4.92f, 7.412f, 4.91f)
                curveTo(7.402f, 4.89f, 7.396f, 4.858f, 7.39f, 4.813f)
                lineTo(7.36f, 4.817f)
                curveTo(7.366f, 4.862f, 7.373f, 4.898f, 7.384f, 4.922f)
                curveTo(7.39f, 4.935f, 7.397f, 4.946f, 7.407f, 4.953f)
                curveTo(7.417f, 4.961f, 7.428f, 4.965f, 7.441f, 4.965f)
                verticalLineTo(4.935f)
                close()
                moveTo(7.468f, 4.89f)
                curveTo(7.468f, 4.911f, 7.464f, 4.922f, 7.459f, 4.928f)
                curveTo(7.455f, 4.932f, 7.45f, 4.935f, 7.441f, 4.935f)
                verticalLineTo(4.965f)
                curveTo(7.456f, 4.965f, 7.472f, 4.96f, 7.483f, 4.946f)
                curveTo(7.493f, 4.933f, 7.498f, 4.914f, 7.498f, 4.89f)
                horizontalLineTo(7.468f)
                close()
                moveTo(7.437f, 4.806f)
                curveTo(7.454f, 4.834f, 7.468f, 4.856f, 7.468f, 4.89f)
                horizontalLineTo(7.498f)
                curveTo(7.498f, 4.847f, 7.48f, 4.818f, 7.463f, 4.79f)
                lineTo(7.437f, 4.806f)
                close()
                moveTo(7.409f, 4.751f)
                curveTo(7.417f, 4.772f, 7.428f, 4.79f, 7.437f, 4.806f)
                lineTo(7.463f, 4.79f)
                curveTo(7.453f, 4.774f, 7.444f, 4.759f, 7.437f, 4.741f)
                lineTo(7.409f, 4.751f)
                close()
                moveTo(7.445f, 4.576f)
                curveTo(7.4f, 4.623f, 7.386f, 4.691f, 7.409f, 4.751f)
                lineTo(7.437f, 4.741f)
                curveTo(7.418f, 4.691f, 7.43f, 4.635f, 7.467f, 4.598f)
                lineTo(7.445f, 4.576f)
                close()
                moveTo(7.477f, 4.627f)
                curveTo(7.476f, 4.615f, 7.473f, 4.6f, 7.471f, 4.585f)
                lineTo(7.441f, 4.589f)
                curveTo(7.444f, 4.605f, 7.446f, 4.619f, 7.448f, 4.632f)
                lineTo(7.477f, 4.627f)
                close()
                moveTo(7.477f, 4.627f)
                lineTo(7.477f, 4.627f)
                lineTo(7.448f, 4.632f)
                lineTo(7.448f, 4.632f)
                lineTo(7.477f, 4.627f)
                close()
                moveTo(7.507f, 4.698f)
                curveTo(7.501f, 4.698f, 7.498f, 4.697f, 7.496f, 4.696f)
                curveTo(7.494f, 4.694f, 7.492f, 4.692f, 7.49f, 4.687f)
                curveTo(7.485f, 4.676f, 7.482f, 4.658f, 7.477f, 4.627f)
                lineTo(7.448f, 4.632f)
                curveTo(7.452f, 4.66f, 7.455f, 4.684f, 7.462f, 4.699f)
                curveTo(7.466f, 4.708f, 7.471f, 4.716f, 7.48f, 4.721f)
                curveTo(7.488f, 4.726f, 7.497f, 4.728f, 7.507f, 4.728f)
                verticalLineTo(4.698f)
                close()
                moveTo(7.481f, 4.555f)
                curveTo(7.494f, 4.575f, 7.515f, 4.609f, 7.523f, 4.64f)
                curveTo(7.528f, 4.655f, 7.529f, 4.668f, 7.526f, 4.678f)
                curveTo(7.523f, 4.686f, 7.517f, 4.694f, 7.502f, 4.699f)
                lineTo(7.512f, 4.727f)
                curveTo(7.535f, 4.72f, 7.549f, 4.705f, 7.554f, 4.687f)
                curveTo(7.56f, 4.669f, 7.557f, 4.649f, 7.552f, 4.631f)
                curveTo(7.542f, 4.596f, 7.519f, 4.559f, 7.507f, 4.539f)
                lineTo(7.481f, 4.555f)
                close()
                moveTo(7.476f, 4.547f)
                lineTo(7.481f, 4.555f)
                lineTo(7.507f, 4.54f)
                lineTo(7.502f, 4.531f)
                lineTo(7.476f, 4.547f)
                close()
                moveTo(7.519f, 4.437f)
                curveTo(7.507f, 4.428f, 7.507f, 4.428f, 7.507f, 4.428f)
                curveTo(7.507f, 4.428f, 7.507f, 4.428f, 7.507f, 4.428f)
                curveTo(7.507f, 4.428f, 7.507f, 4.428f, 7.507f, 4.428f)
                curveTo(7.507f, 4.428f, 7.507f, 4.429f, 7.507f, 4.429f)
                curveTo(7.507f, 4.429f, 7.507f, 4.429f, 7.507f, 4.429f)
                curveTo(7.506f, 4.429f, 7.506f, 4.429f, 7.506f, 4.429f)
                curveTo(7.506f, 4.43f, 7.505f, 4.431f, 7.504f, 4.432f)
                curveTo(7.503f, 4.434f, 7.501f, 4.437f, 7.499f, 4.441f)
                curveTo(7.495f, 4.448f, 7.489f, 4.458f, 7.484f, 4.469f)
                curveTo(7.479f, 4.481f, 7.474f, 4.494f, 7.471f, 4.507f)
                curveTo(7.469f, 4.519f, 7.469f, 4.534f, 7.476f, 4.546f)
                lineTo(7.502f, 4.532f)
                curveTo(7.5f, 4.528f, 7.499f, 4.521f, 7.501f, 4.512f)
                curveTo(7.503f, 4.502f, 7.506f, 4.492f, 7.511f, 4.482f)
                curveTo(7.516f, 4.472f, 7.521f, 4.463f, 7.525f, 4.456f)
                curveTo(7.527f, 4.453f, 7.528f, 4.45f, 7.53f, 4.448f)
                curveTo(7.53f, 4.447f, 7.531f, 4.447f, 7.531f, 4.446f)
                curveTo(7.531f, 4.446f, 7.531f, 4.446f, 7.531f, 4.446f)
                curveTo(7.531f, 4.446f, 7.531f, 4.446f, 7.531f, 4.446f)
                curveTo(7.531f, 4.446f, 7.531f, 4.446f, 7.531f, 4.446f)
                curveTo(7.531f, 4.446f, 7.531f, 4.446f, 7.531f, 4.446f)
                curveTo(7.531f, 4.446f, 7.531f, 4.446f, 7.531f, 4.446f)
                curveTo(7.531f, 4.446f, 7.531f, 4.446f, 7.519f, 4.437f)
                close()
                moveTo(7.575f, 4.501f)
                curveTo(7.567f, 4.503f, 7.564f, 4.503f, 7.562f, 4.503f)
                curveTo(7.562f, 4.503f, 7.561f, 4.503f, 7.559f, 4.5f)
                curveTo(7.556f, 4.497f, 7.553f, 4.491f, 7.548f, 4.479f)
                curveTo(7.544f, 4.468f, 7.539f, 4.453f, 7.533f, 4.433f)
                lineTo(7.505f, 4.441f)
                curveTo(7.511f, 4.462f, 7.516f, 4.478f, 7.52f, 4.49f)
                curveTo(7.525f, 4.502f, 7.529f, 4.512f, 7.535f, 4.519f)
                curveTo(7.541f, 4.527f, 7.549f, 4.532f, 7.559f, 4.533f)
                curveTo(7.567f, 4.534f, 7.576f, 4.532f, 7.583f, 4.529f)
                lineTo(7.575f, 4.501f)
                close()
                moveTo(7.556f, 4.424f)
                curveTo(7.576f, 4.443f, 7.586f, 4.463f, 7.587f, 4.478f)
                curveTo(7.588f, 4.485f, 7.587f, 4.491f, 7.585f, 4.494f)
                curveTo(7.584f, 4.497f, 7.581f, 4.499f, 7.575f, 4.5f)
                lineTo(7.583f, 4.53f)
                curveTo(7.595f, 4.526f, 7.605f, 4.519f, 7.611f, 4.509f)
                curveTo(7.617f, 4.498f, 7.619f, 4.486f, 7.617f, 4.475f)
                curveTo(7.614f, 4.451f, 7.6f, 4.425f, 7.578f, 4.402f)
                lineTo(7.556f, 4.424f)
                close()
                moveTo(7.562f, 4.303f)
                curveTo(7.545f, 4.321f, 7.535f, 4.341f, 7.534f, 4.363f)
                curveTo(7.532f, 4.384f, 7.54f, 4.405f, 7.556f, 4.423f)
                lineTo(7.578f, 4.403f)
                curveTo(7.567f, 4.391f, 7.563f, 4.377f, 7.564f, 4.364f)
                curveTo(7.564f, 4.351f, 7.571f, 4.337f, 7.584f, 4.325f)
                lineTo(7.562f, 4.303f)
                close()
                moveTo(7.627f, 4.331f)
                curveTo(7.627f, 4.338f, 7.625f, 4.341f, 7.623f, 4.342f)
                curveTo(7.623f, 4.343f, 7.622f, 4.343f, 7.62f, 4.343f)
                curveTo(7.614f, 4.342f, 7.601f, 4.334f, 7.586f, 4.307f)
                lineTo(7.56f, 4.321f)
                curveTo(7.575f, 4.351f, 7.595f, 4.37f, 7.616f, 4.373f)
                curveTo(7.627f, 4.374f, 7.637f, 4.371f, 7.645f, 4.363f)
                curveTo(7.652f, 4.355f, 7.656f, 4.344f, 7.657f, 4.333f)
                lineTo(7.627f, 4.331f)
                close()
                moveTo(7.603f, 4.203f)
                lineTo(7.627f, 4.335f)
                lineTo(7.657f, 4.329f)
                lineTo(7.633f, 4.197f)
                lineTo(7.603f, 4.203f)
                close()
                moveTo(7.651f, 4.185f)
                horizontalLineTo(7.618f)
                verticalLineTo(4.215f)
                horizontalLineTo(7.651f)
                verticalLineTo(4.185f)
                close()
                moveTo(7.624f, 4.102f)
                lineTo(7.636f, 4.202f)
                lineTo(7.666f, 4.198f)
                lineTo(7.654f, 4.098f)
                lineTo(7.624f, 4.102f)
                close()
                moveTo(8.116f, 4.085f)
                horizontalLineTo(7.639f)
                verticalLineTo(4.115f)
                horizontalLineTo(8.116f)
                verticalLineTo(4.085f)
                close()
                moveTo(8.119f, 4.202f)
                lineTo(8.131f, 4.102f)
                lineTo(8.101f, 4.098f)
                lineTo(8.089f, 4.198f)
                lineTo(8.119f, 4.202f)
                close()
                moveTo(8.14f, 4.185f)
                horizontalLineTo(8.104f)
                verticalLineTo(4.215f)
                horizontalLineTo(8.14f)
                verticalLineTo(4.185f)
                close()
                moveTo(8.128f, 4.332f)
                lineTo(8.155f, 4.203f)
                lineTo(8.125f, 4.197f)
                lineTo(8.098f, 4.326f)
                lineTo(8.128f, 4.332f)
                close()
                moveTo(8.172f, 4.307f)
                curveTo(8.158f, 4.335f, 8.142f, 4.342f, 8.135f, 4.343f)
                curveTo(8.131f, 4.343f, 8.13f, 4.342f, 8.129f, 4.341f)
                curveTo(8.128f, 4.34f, 8.127f, 4.337f, 8.128f, 4.331f)
                lineTo(8.098f, 4.327f)
                curveTo(8.096f, 4.339f, 8.099f, 4.351f, 8.106f, 4.36f)
                curveTo(8.114f, 4.369f, 8.125f, 4.373f, 8.136f, 4.372f)
                curveTo(8.159f, 4.371f, 8.182f, 4.353f, 8.198f, 4.321f)
                lineTo(8.172f, 4.307f)
                close()
                moveTo(8.202f, 4.424f)
                curveTo(8.236f, 4.39f, 8.23f, 4.338f, 8.196f, 4.303f)
                lineTo(8.174f, 4.325f)
                curveTo(8.2f, 4.35f, 8.2f, 4.382f, 8.18f, 4.402f)
                lineTo(8.202f, 4.424f)
                close()
                moveTo(8.183f, 4.5f)
                curveTo(8.177f, 4.499f, 8.174f, 4.497f, 8.173f, 4.494f)
                curveTo(8.171f, 4.491f, 8.17f, 4.485f, 8.171f, 4.478f)
                curveTo(8.172f, 4.463f, 8.182f, 4.443f, 8.202f, 4.424f)
                lineTo(8.18f, 4.402f)
                curveTo(8.158f, 4.425f, 8.144f, 4.451f, 8.141f, 4.475f)
                curveTo(8.14f, 4.486f, 8.141f, 4.498f, 8.147f, 4.509f)
                curveTo(8.153f, 4.519f, 8.163f, 4.526f, 8.175f, 4.53f)
                lineTo(8.183f, 4.5f)
                close()
                moveTo(8.225f, 4.433f)
                curveTo(8.219f, 4.452f, 8.214f, 4.467f, 8.21f, 4.478f)
                curveTo(8.205f, 4.489f, 8.202f, 4.496f, 8.199f, 4.5f)
                curveTo(8.197f, 4.503f, 8.196f, 4.503f, 8.195f, 4.503f)
                curveTo(8.194f, 4.503f, 8.191f, 4.503f, 8.183f, 4.501f)
                lineTo(8.175f, 4.529f)
                curveTo(8.183f, 4.532f, 8.191f, 4.534f, 8.2f, 4.532f)
                curveTo(8.21f, 4.531f, 8.217f, 4.526f, 8.223f, 4.518f)
                curveTo(8.229f, 4.51f, 8.233f, 4.501f, 8.238f, 4.489f)
                curveTo(8.242f, 4.477f, 8.247f, 4.461f, 8.253f, 4.441f)
                lineTo(8.225f, 4.433f)
                close()
                moveTo(8.284f, 4.543f)
                curveTo(8.292f, 4.51f, 8.283f, 4.48f, 8.273f, 4.46f)
                curveTo(8.268f, 4.45f, 8.262f, 4.441f, 8.258f, 4.436f)
                curveTo(8.255f, 4.433f, 8.254f, 4.431f, 8.252f, 4.429f)
                curveTo(8.251f, 4.428f, 8.251f, 4.428f, 8.25f, 4.427f)
                curveTo(8.25f, 4.427f, 8.25f, 4.427f, 8.25f, 4.427f)
                curveTo(8.25f, 4.427f, 8.25f, 4.427f, 8.25f, 4.426f)
                curveTo(8.25f, 4.426f, 8.25f, 4.426f, 8.25f, 4.426f)
                curveTo(8.25f, 4.426f, 8.25f, 4.426f, 8.25f, 4.426f)
                curveTo(8.25f, 4.426f, 8.25f, 4.426f, 8.25f, 4.426f)
                curveTo(8.25f, 4.426f, 8.25f, 4.426f, 8.239f, 4.437f)
                curveTo(8.228f, 4.448f, 8.228f, 4.448f, 8.228f, 4.448f)
                curveTo(8.228f, 4.448f, 8.228f, 4.448f, 8.228f, 4.448f)
                curveTo(8.228f, 4.448f, 8.228f, 4.448f, 8.228f, 4.448f)
                curveTo(8.228f, 4.448f, 8.228f, 4.448f, 8.228f, 4.448f)
                curveTo(8.228f, 4.448f, 8.228f, 4.448f, 8.228f, 4.448f)
                curveTo(8.228f, 4.448f, 8.229f, 4.448f, 8.229f, 4.448f)
                curveTo(8.229f, 4.448f, 8.229f, 4.448f, 8.23f, 4.449f)
                curveTo(8.231f, 4.45f, 8.232f, 4.452f, 8.234f, 4.454f)
                curveTo(8.238f, 4.459f, 8.242f, 4.465f, 8.246f, 4.473f)
                curveTo(8.255f, 4.49f, 8.261f, 4.511f, 8.255f, 4.535f)
                lineTo(8.284f, 4.543f)
                close()
                moveTo(8.277f, 4.554f)
                lineTo(8.282f, 4.547f)
                lineTo(8.256f, 4.531f)
                lineTo(8.252f, 4.538f)
                lineTo(8.277f, 4.554f)
                close()
                moveTo(8.255f, 4.699f)
                curveTo(8.241f, 4.694f, 8.235f, 4.687f, 8.232f, 4.679f)
                curveTo(8.229f, 4.669f, 8.23f, 4.656f, 8.235f, 4.64f)
                curveTo(8.244f, 4.608f, 8.265f, 4.574f, 8.277f, 4.554f)
                lineTo(8.252f, 4.538f)
                curveTo(8.24f, 4.557f, 8.217f, 4.595f, 8.206f, 4.632f)
                curveTo(8.201f, 4.65f, 8.198f, 4.67f, 8.204f, 4.687f)
                curveTo(8.209f, 4.706f, 8.224f, 4.721f, 8.247f, 4.727f)
                lineTo(8.255f, 4.699f)
                close()
                moveTo(8.281f, 4.627f)
                curveTo(8.276f, 4.658f, 8.273f, 4.676f, 8.268f, 4.687f)
                curveTo(8.266f, 4.692f, 8.264f, 4.694f, 8.262f, 4.696f)
                curveTo(8.26f, 4.697f, 8.257f, 4.698f, 8.251f, 4.698f)
                verticalLineTo(4.728f)
                curveTo(8.261f, 4.728f, 8.27f, 4.726f, 8.278f, 4.721f)
                curveTo(8.287f, 4.716f, 8.292f, 4.708f, 8.296f, 4.699f)
                curveTo(8.303f, 4.684f, 8.306f, 4.66f, 8.31f, 4.632f)
                lineTo(8.281f, 4.627f)
                close()
                moveTo(8.281f, 4.627f)
                lineTo(8.281f, 4.628f)
                lineTo(8.31f, 4.631f)
                lineTo(8.31f, 4.631f)
                lineTo(8.281f, 4.627f)
                close()
                moveTo(8.281f, 4.627f)
                lineTo(8.281f, 4.627f)
                lineTo(8.31f, 4.632f)
                lineTo(8.31f, 4.632f)
                lineTo(8.281f, 4.627f)
                close()
                moveTo(8.287f, 4.585f)
                curveTo(8.285f, 4.6f, 8.283f, 4.615f, 8.281f, 4.627f)
                lineTo(8.31f, 4.632f)
                curveTo(8.312f, 4.619f, 8.314f, 4.605f, 8.317f, 4.589f)
                lineTo(8.287f, 4.585f)
                close()
                moveTo(8.346f, 4.752f)
                curveTo(8.37f, 4.692f, 8.357f, 4.624f, 8.313f, 4.577f)
                lineTo(8.291f, 4.597f)
                curveTo(8.327f, 4.636f, 8.338f, 4.692f, 8.318f, 4.74f)
                lineTo(8.346f, 4.752f)
                close()
                moveTo(8.317f, 4.809f)
                curveTo(8.327f, 4.793f, 8.339f, 4.774f, 8.346f, 4.751f)
                lineTo(8.318f, 4.741f)
                curveTo(8.311f, 4.76f, 8.302f, 4.777f, 8.291f, 4.794f)
                lineTo(8.317f, 4.809f)
                close()
                moveTo(8.287f, 4.89f)
                curveTo(8.287f, 4.858f, 8.3f, 4.836f, 8.317f, 4.809f)
                lineTo(8.291f, 4.794f)
                curveTo(8.275f, 4.82f, 8.257f, 4.849f, 8.257f, 4.89f)
                horizontalLineTo(8.287f)
                close()
                moveTo(8.317f, 4.935f)
                curveTo(8.308f, 4.935f, 8.302f, 4.932f, 8.297f, 4.927f)
                curveTo(8.292f, 4.921f, 8.287f, 4.91f, 8.287f, 4.89f)
                horizontalLineTo(8.257f)
                curveTo(8.257f, 4.915f, 8.263f, 4.934f, 8.274f, 4.947f)
                curveTo(8.286f, 4.96f, 8.302f, 4.965f, 8.317f, 4.965f)
                verticalLineTo(4.935f)
                close()
                moveTo(8.368f, 4.813f)
                curveTo(8.362f, 4.86f, 8.356f, 4.891f, 8.347f, 4.911f)
                curveTo(8.342f, 4.921f, 8.338f, 4.927f, 8.333f, 4.93f)
                curveTo(8.329f, 4.933f, 8.324f, 4.935f, 8.317f, 4.935f)
                verticalLineTo(4.965f)
                curveTo(8.33f, 4.965f, 8.341f, 4.962f, 8.351f, 4.954f)
                curveTo(8.361f, 4.947f, 8.368f, 4.936f, 8.374f, 4.924f)
                curveTo(8.385f, 4.899f, 8.392f, 4.863f, 8.398f, 4.817f)
                lineTo(8.368f, 4.813f)
                close()
                moveTo(8.417f, 5.003f)
                curveTo(8.425f, 4.991f, 8.428f, 4.975f, 8.43f, 4.959f)
                curveTo(8.432f, 4.942f, 8.431f, 4.923f, 8.429f, 4.904f)
                curveTo(8.424f, 4.868f, 8.412f, 4.828f, 8.395f, 4.806f)
                lineTo(8.371f, 4.824f)
                curveTo(8.384f, 4.841f, 8.395f, 4.873f, 8.399f, 4.908f)
                curveTo(8.401f, 4.925f, 8.402f, 4.942f, 8.4f, 4.956f)
                curveTo(8.399f, 4.97f, 8.396f, 4.981f, 8.392f, 4.987f)
                lineTo(8.417f, 5.003f)
                close()
                moveTo(8.391f, 5.041f)
                lineTo(8.416f, 5.003f)
                lineTo(8.392f, 4.987f)
                lineTo(8.366f, 5.024f)
                lineTo(8.391f, 5.041f)
                close()
                moveTo(8.317f, 5.181f)
                curveTo(8.317f, 5.166f, 8.322f, 5.151f, 8.334f, 5.129f)
                curveTo(8.346f, 5.106f, 8.365f, 5.079f, 8.391f, 5.041f)
                lineTo(8.366f, 5.024f)
                curveTo(8.341f, 5.061f, 8.321f, 5.09f, 8.308f, 5.114f)
                curveTo(8.295f, 5.138f, 8.287f, 5.159f, 8.287f, 5.181f)
                horizontalLineTo(8.317f)
                close()
                moveTo(8.377f, 5.129f)
                curveTo(8.37f, 5.158f, 8.361f, 5.178f, 8.353f, 5.19f)
                curveTo(8.344f, 5.202f, 8.337f, 5.206f, 8.333f, 5.206f)
                curveTo(8.33f, 5.207f, 8.327f, 5.206f, 8.323f, 5.202f)
                curveTo(8.32f, 5.198f, 8.317f, 5.191f, 8.317f, 5.181f)
                horizontalLineTo(8.287f)
                curveTo(8.287f, 5.197f, 8.292f, 5.211f, 8.3f, 5.222f)
                curveTo(8.309f, 5.232f, 8.323f, 5.239f, 8.338f, 5.236f)
                curveTo(8.353f, 5.233f, 8.367f, 5.223f, 8.378f, 5.207f)
                curveTo(8.389f, 5.191f, 8.399f, 5.168f, 8.407f, 5.137f)
                lineTo(8.377f, 5.129f)
                close()
                moveTo(8.407f, 5.265f)
                curveTo(8.422f, 5.267f, 8.422f, 5.267f, 8.422f, 5.267f)
                curveTo(8.422f, 5.267f, 8.422f, 5.267f, 8.422f, 5.267f)
                curveTo(8.422f, 5.267f, 8.422f, 5.267f, 8.422f, 5.267f)
                curveTo(8.422f, 5.267f, 8.422f, 5.267f, 8.422f, 5.267f)
                curveTo(8.422f, 5.267f, 8.422f, 5.267f, 8.422f, 5.267f)
                curveTo(8.422f, 5.266f, 8.422f, 5.266f, 8.422f, 5.266f)
                curveTo(8.422f, 5.265f, 8.422f, 5.264f, 8.422f, 5.263f)
                curveTo(8.423f, 5.26f, 8.423f, 5.256f, 8.423f, 5.251f)
                curveTo(8.424f, 5.242f, 8.425f, 5.229f, 8.425f, 5.215f)
                curveTo(8.424f, 5.187f, 8.421f, 5.15f, 8.405f, 5.125f)
                lineTo(8.379f, 5.141f)
                curveTo(8.39f, 5.158f, 8.394f, 5.187f, 8.395f, 5.215f)
                curveTo(8.395f, 5.228f, 8.394f, 5.24f, 8.394f, 5.249f)
                curveTo(8.393f, 5.253f, 8.393f, 5.257f, 8.393f, 5.259f)
                curveTo(8.392f, 5.261f, 8.392f, 5.262f, 8.392f, 5.262f)
                curveTo(8.392f, 5.262f, 8.392f, 5.263f, 8.392f, 5.263f)
                curveTo(8.392f, 5.263f, 8.392f, 5.263f, 8.392f, 5.263f)
                curveTo(8.392f, 5.263f, 8.392f, 5.263f, 8.392f, 5.263f)
                curveTo(8.392f, 5.263f, 8.392f, 5.263f, 8.392f, 5.263f)
                curveTo(8.392f, 5.263f, 8.392f, 5.263f, 8.392f, 5.263f)
                curveTo(8.392f, 5.263f, 8.392f, 5.263f, 8.407f, 5.265f)
                close()
                moveTo(8.381f, 5.338f)
                curveTo(8.399f, 5.321f, 8.422f, 5.3f, 8.422f, 5.265f)
                horizontalLineTo(8.392f)
                curveTo(8.392f, 5.285f, 8.38f, 5.297f, 8.361f, 5.316f)
                lineTo(8.381f, 5.338f)
                close()
                moveTo(8.338f, 5.416f)
                curveTo(8.339f, 5.377f, 8.359f, 5.358f, 8.381f, 5.338f)
                lineTo(8.361f, 5.316f)
                curveTo(8.338f, 5.336f, 8.31f, 5.363f, 8.308f, 5.414f)
                lineTo(8.338f, 5.416f)
                close()
                moveTo(8.338f, 5.52f)
                verticalLineTo(5.415f)
                horizontalLineTo(8.308f)
                verticalLineTo(5.52f)
                horizontalLineTo(8.338f)
                close()
                moveTo(5.152f, 4.68f)
                verticalLineTo(5.52f)
                horizontalLineTo(5.182f)
                verticalLineTo(4.68f)
                horizontalLineTo(5.152f)
                close()
                moveTo(5.216f, 4.718f)
                curveTo(5.21f, 4.706f, 5.205f, 4.694f, 5.198f, 4.685f)
                curveTo(5.192f, 4.676f, 5.182f, 4.665f, 5.167f, 4.665f)
                verticalLineTo(4.695f)
                curveTo(5.167f, 4.695f, 5.167f, 4.695f, 5.167f, 4.695f)
                curveTo(5.167f, 4.695f, 5.167f, 4.695f, 5.167f, 4.695f)
                curveTo(5.167f, 4.695f, 5.167f, 4.695f, 5.167f, 4.695f)
                curveTo(5.167f, 4.695f, 5.167f, 4.695f, 5.168f, 4.696f)
                curveTo(5.169f, 4.697f, 5.171f, 4.698f, 5.173f, 4.702f)
                curveTo(5.178f, 4.709f, 5.183f, 4.718f, 5.189f, 4.731f)
                lineTo(5.216f, 4.718f)
                close()
                moveTo(5.293f, 4.794f)
                curveTo(5.273f, 4.794f, 5.259f, 4.785f, 5.247f, 4.771f)
                curveTo(5.234f, 4.756f, 5.225f, 4.737f, 5.216f, 4.718f)
                lineTo(5.189f, 4.731f)
                curveTo(5.197f, 4.749f, 5.208f, 4.772f, 5.224f, 4.791f)
                curveTo(5.24f, 4.809f, 5.262f, 4.824f, 5.293f, 4.824f)
                verticalLineTo(4.794f)
                close()
                moveTo(5.295f, 4.721f)
                curveTo(5.308f, 4.74f, 5.314f, 4.761f, 5.313f, 4.776f)
                curveTo(5.312f, 4.783f, 5.31f, 4.787f, 5.307f, 4.789f)
                curveTo(5.305f, 4.792f, 5.301f, 4.794f, 5.293f, 4.794f)
                verticalLineTo(4.824f)
                curveTo(5.307f, 4.824f, 5.32f, 4.82f, 5.329f, 4.81f)
                curveTo(5.338f, 4.801f, 5.342f, 4.79f, 5.343f, 4.778f)
                curveTo(5.344f, 4.755f, 5.335f, 4.728f, 5.321f, 4.705f)
                lineTo(5.295f, 4.721f)
                close()
                moveTo(5.282f, 4.519f)
                curveTo(5.263f, 4.57f, 5.261f, 4.61f, 5.266f, 4.643f)
                curveTo(5.271f, 4.676f, 5.284f, 4.701f, 5.295f, 4.72f)
                lineTo(5.321f, 4.706f)
                curveTo(5.311f, 4.686f, 5.3f, 4.666f, 5.295f, 4.639f)
                curveTo(5.291f, 4.612f, 5.293f, 4.577f, 5.31f, 4.529f)
                lineTo(5.282f, 4.519f)
                close()
                moveTo(5.363f, 4.582f)
                curveTo(5.365f, 4.592f, 5.361f, 4.589f, 5.366f, 4.586f)
                curveTo(5.367f, 4.585f, 5.368f, 4.586f, 5.366f, 4.586f)
                curveTo(5.364f, 4.585f, 5.362f, 4.585f, 5.358f, 4.583f)
                curveTo(5.344f, 4.575f, 5.323f, 4.554f, 5.31f, 4.519f)
                lineTo(5.282f, 4.529f)
                curveTo(5.296f, 4.569f, 5.322f, 4.597f, 5.344f, 4.609f)
                curveTo(5.35f, 4.612f, 5.356f, 4.614f, 5.362f, 4.615f)
                curveTo(5.368f, 4.616f, 5.375f, 4.616f, 5.381f, 4.612f)
                curveTo(5.395f, 4.604f, 5.395f, 4.587f, 5.392f, 4.574f)
                lineTo(5.363f, 4.582f)
                close()
                moveTo(5.336f, 4.523f)
                curveTo(5.347f, 4.541f, 5.356f, 4.558f, 5.363f, 4.582f)
                lineTo(5.392f, 4.574f)
                curveTo(5.384f, 4.547f, 5.373f, 4.526f, 5.362f, 4.508f)
                lineTo(5.336f, 4.523f)
                close()
                moveTo(5.327f, 4.354f)
                curveTo(5.31f, 4.397f, 5.306f, 4.429f, 5.31f, 4.456f)
                curveTo(5.314f, 4.483f, 5.325f, 4.504f, 5.336f, 4.523f)
                lineTo(5.362f, 4.508f)
                curveTo(5.351f, 4.489f, 5.342f, 4.473f, 5.339f, 4.452f)
                curveTo(5.337f, 4.432f, 5.339f, 4.405f, 5.355f, 4.364f)
                lineTo(5.327f, 4.354f)
                close()
                moveTo(5.392f, 4.402f)
                curveTo(5.396f, 4.415f, 5.394f, 4.421f, 5.392f, 4.424f)
                curveTo(5.392f, 4.424f, 5.392f, 4.425f, 5.392f, 4.425f)
                curveTo(5.391f, 4.425f, 5.391f, 4.425f, 5.391f, 4.425f)
                curveTo(5.391f, 4.425f, 5.391f, 4.425f, 5.389f, 4.425f)
                curveTo(5.386f, 4.424f, 5.379f, 4.42f, 5.373f, 4.409f)
                curveTo(5.366f, 4.398f, 5.359f, 4.381f, 5.356f, 4.357f)
                lineTo(5.326f, 4.361f)
                curveTo(5.33f, 4.388f, 5.338f, 4.409f, 5.347f, 4.424f)
                curveTo(5.356f, 4.439f, 5.368f, 4.45f, 5.381f, 4.454f)
                curveTo(5.388f, 4.456f, 5.395f, 4.456f, 5.402f, 4.453f)
                curveTo(5.409f, 4.45f, 5.414f, 4.445f, 5.418f, 4.439f)
                curveTo(5.425f, 4.427f, 5.426f, 4.411f, 5.422f, 4.394f)
                lineTo(5.392f, 4.402f)
                close()
                moveTo(5.378f, 4.359f)
                curveTo(5.383f, 4.372f, 5.388f, 4.386f, 5.393f, 4.402f)
                lineTo(5.422f, 4.394f)
                curveTo(5.417f, 4.377f, 5.411f, 4.361f, 5.406f, 4.348f)
                lineTo(5.378f, 4.359f)
                close()
                moveTo(5.385f, 4.196f)
                curveTo(5.366f, 4.234f, 5.359f, 4.264f, 5.36f, 4.29f)
                curveTo(5.361f, 4.316f, 5.37f, 4.338f, 5.378f, 4.359f)
                lineTo(5.406f, 4.348f)
                curveTo(5.397f, 4.326f, 5.391f, 4.309f, 5.39f, 4.289f)
                curveTo(5.389f, 4.269f, 5.394f, 4.244f, 5.411f, 4.21f)
                lineTo(5.385f, 4.196f)
                close()
                moveTo(5.443f, 4.239f)
                curveTo(5.443f, 4.255f, 5.441f, 4.266f, 5.439f, 4.272f)
                curveTo(5.437f, 4.275f, 5.437f, 4.276f, 5.437f, 4.275f)
                curveTo(5.439f, 4.274f, 5.441f, 4.274f, 5.443f, 4.274f)
                curveTo(5.444f, 4.274f, 5.443f, 4.274f, 5.44f, 4.272f)
                curveTo(5.438f, 4.269f, 5.435f, 4.265f, 5.432f, 4.259f)
                curveTo(5.426f, 4.246f, 5.419f, 4.227f, 5.413f, 4.199f)
                lineTo(5.383f, 4.207f)
                curveTo(5.39f, 4.235f, 5.398f, 4.256f, 5.405f, 4.272f)
                curveTo(5.409f, 4.279f, 5.413f, 4.286f, 5.417f, 4.291f)
                curveTo(5.422f, 4.296f, 5.427f, 4.301f, 5.434f, 4.303f)
                curveTo(5.441f, 4.305f, 5.449f, 4.304f, 5.455f, 4.299f)
                curveTo(5.461f, 4.295f, 5.464f, 4.289f, 5.466f, 4.284f)
                curveTo(5.471f, 4.273f, 5.473f, 4.257f, 5.473f, 4.239f)
                horizontalLineTo(5.443f)
                close()
                moveTo(5.58f, 3.976f)
                curveTo(5.512f, 3.997f, 5.477f, 4.037f, 5.46f, 4.086f)
                curveTo(5.443f, 4.133f, 5.443f, 4.189f, 5.443f, 4.239f)
                horizontalLineTo(5.473f)
                curveTo(5.473f, 4.187f, 5.473f, 4.138f, 5.488f, 4.096f)
                curveTo(5.502f, 4.056f, 5.53f, 4.022f, 5.588f, 4.004f)
                lineTo(5.58f, 3.976f)
                close()
                moveTo(5.641f, 3.885f)
                curveTo(5.624f, 3.885f, 5.61f, 3.893f, 5.601f, 3.904f)
                curveTo(5.591f, 3.914f, 5.585f, 3.928f, 5.58f, 3.94f)
                curveTo(5.576f, 3.952f, 5.573f, 3.964f, 5.571f, 3.973f)
                curveTo(5.571f, 3.978f, 5.57f, 3.981f, 5.57f, 3.984f)
                curveTo(5.569f, 3.985f, 5.569f, 3.986f, 5.569f, 3.987f)
                curveTo(5.569f, 3.988f, 5.569f, 3.988f, 5.569f, 3.988f)
                curveTo(5.569f, 3.988f, 5.569f, 3.988f, 5.569f, 3.988f)
                curveTo(5.569f, 3.988f, 5.569f, 3.988f, 5.569f, 3.988f)
                curveTo(5.569f, 3.988f, 5.569f, 3.988f, 5.569f, 3.988f)
                curveTo(5.569f, 3.988f, 5.569f, 3.989f, 5.569f, 3.989f)
                curveTo(5.569f, 3.989f, 5.569f, 3.989f, 5.584f, 3.99f)
                curveTo(5.599f, 3.991f, 5.599f, 3.991f, 5.599f, 3.991f)
                curveTo(5.599f, 3.991f, 5.599f, 3.991f, 5.599f, 3.992f)
                curveTo(5.599f, 3.992f, 5.599f, 3.992f, 5.599f, 3.992f)
                curveTo(5.599f, 3.992f, 5.599f, 3.991f, 5.599f, 3.991f)
                curveTo(5.599f, 3.991f, 5.599f, 3.991f, 5.599f, 3.991f)
                curveTo(5.599f, 3.991f, 5.599f, 3.991f, 5.599f, 3.991f)
                curveTo(5.599f, 3.99f, 5.599f, 3.989f, 5.599f, 3.988f)
                curveTo(5.6f, 3.986f, 5.6f, 3.983f, 5.601f, 3.979f)
                curveTo(5.602f, 3.971f, 5.605f, 3.96f, 5.609f, 3.95f)
                curveTo(5.612f, 3.94f, 5.617f, 3.931f, 5.623f, 3.924f)
                curveTo(5.629f, 3.918f, 5.634f, 3.915f, 5.641f, 3.915f)
                verticalLineTo(3.885f)
                close()
                moveTo(5.695f, 3.99f)
                curveTo(5.71f, 3.989f, 5.71f, 3.989f, 5.71f, 3.989f)
                curveTo(5.71f, 3.989f, 5.71f, 3.988f, 5.71f, 3.988f)
                curveTo(5.71f, 3.988f, 5.71f, 3.988f, 5.71f, 3.988f)
                curveTo(5.71f, 3.988f, 5.71f, 3.988f, 5.71f, 3.988f)
                curveTo(5.71f, 3.988f, 5.71f, 3.988f, 5.71f, 3.988f)
                curveTo(5.71f, 3.988f, 5.71f, 3.988f, 5.71f, 3.987f)
                curveTo(5.71f, 3.987f, 5.71f, 3.985f, 5.709f, 3.984f)
                curveTo(5.709f, 3.981f, 5.709f, 3.978f, 5.708f, 3.973f)
                curveTo(5.706f, 3.964f, 5.703f, 3.952f, 5.699f, 3.94f)
                curveTo(5.695f, 3.928f, 5.689f, 3.915f, 5.68f, 3.904f)
                curveTo(5.671f, 3.894f, 5.658f, 3.885f, 5.641f, 3.885f)
                verticalLineTo(3.915f)
                curveTo(5.647f, 3.915f, 5.652f, 3.918f, 5.657f, 3.924f)
                curveTo(5.663f, 3.93f, 5.667f, 3.94f, 5.671f, 3.95f)
                curveTo(5.674f, 3.96f, 5.677f, 3.971f, 5.678f, 3.979f)
                curveTo(5.679f, 3.983f, 5.679f, 3.986f, 5.68f, 3.988f)
                curveTo(5.68f, 3.989f, 5.68f, 3.99f, 5.68f, 3.991f)
                curveTo(5.68f, 3.991f, 5.68f, 3.991f, 5.68f, 3.991f)
                curveTo(5.68f, 3.991f, 5.68f, 3.991f, 5.68f, 3.991f)
                curveTo(5.68f, 3.991f, 5.68f, 3.992f, 5.68f, 3.992f)
                curveTo(5.68f, 3.992f, 5.68f, 3.992f, 5.68f, 3.991f)
                curveTo(5.68f, 3.991f, 5.68f, 3.991f, 5.68f, 3.991f)
                curveTo(5.68f, 3.991f, 5.68f, 3.991f, 5.695f, 3.99f)
                close()
                moveTo(5.836f, 4.232f)
                curveTo(5.836f, 4.184f, 5.836f, 4.131f, 5.819f, 4.084f)
                curveTo(5.802f, 4.036f, 5.767f, 3.996f, 5.699f, 3.976f)
                lineTo(5.691f, 4.004f)
                curveTo(5.749f, 4.022f, 5.777f, 4.055f, 5.791f, 4.094f)
                curveTo(5.806f, 4.135f, 5.806f, 4.183f, 5.806f, 4.232f)
                lineTo(5.836f, 4.232f)
                close()
                moveTo(5.836f, 4.239f)
                lineTo(5.836f, 4.232f)
                lineTo(5.806f, 4.232f)
                lineTo(5.806f, 4.239f)
                lineTo(5.836f, 4.239f)
                close()
                moveTo(5.866f, 4.199f)
                curveTo(5.86f, 4.227f, 5.853f, 4.246f, 5.847f, 4.259f)
                curveTo(5.844f, 4.265f, 5.841f, 4.269f, 5.839f, 4.272f)
                curveTo(5.836f, 4.274f, 5.835f, 4.274f, 5.836f, 4.274f)
                curveTo(5.838f, 4.274f, 5.84f, 4.274f, 5.842f, 4.275f)
                curveTo(5.842f, 4.276f, 5.842f, 4.275f, 5.84f, 4.272f)
                curveTo(5.838f, 4.266f, 5.836f, 4.255f, 5.836f, 4.239f)
                horizontalLineTo(5.806f)
                curveTo(5.806f, 4.257f, 5.808f, 4.273f, 5.813f, 4.284f)
                curveTo(5.815f, 4.289f, 5.819f, 4.295f, 5.824f, 4.299f)
                curveTo(5.83f, 4.304f, 5.838f, 4.305f, 5.846f, 4.303f)
                curveTo(5.852f, 4.301f, 5.858f, 4.296f, 5.862f, 4.291f)
                curveTo(5.866f, 4.286f, 5.87f, 4.279f, 5.874f, 4.272f)
                curveTo(5.881f, 4.256f, 5.889f, 4.235f, 5.896f, 4.207f)
                lineTo(5.866f, 4.199f)
                close()
                moveTo(5.901f, 4.359f)
                curveTo(5.909f, 4.338f, 5.918f, 4.316f, 5.919f, 4.29f)
                curveTo(5.92f, 4.264f, 5.913f, 4.234f, 5.894f, 4.196f)
                lineTo(5.868f, 4.21f)
                curveTo(5.885f, 4.244f, 5.89f, 4.269f, 5.889f, 4.289f)
                curveTo(5.888f, 4.309f, 5.882f, 4.326f, 5.873f, 4.348f)
                lineTo(5.901f, 4.359f)
                close()
                moveTo(5.887f, 4.402f)
                curveTo(5.891f, 4.386f, 5.896f, 4.372f, 5.901f, 4.359f)
                lineTo(5.873f, 4.348f)
                curveTo(5.868f, 4.361f, 5.862f, 4.377f, 5.858f, 4.394f)
                lineTo(5.887f, 4.402f)
                close()
                moveTo(5.923f, 4.357f)
                curveTo(5.92f, 4.381f, 5.913f, 4.398f, 5.907f, 4.409f)
                curveTo(5.9f, 4.42f, 5.893f, 4.424f, 5.89f, 4.425f)
                curveTo(5.888f, 4.425f, 5.888f, 4.425f, 5.888f, 4.425f)
                curveTo(5.888f, 4.425f, 5.888f, 4.425f, 5.888f, 4.425f)
                curveTo(5.887f, 4.425f, 5.887f, 4.424f, 5.887f, 4.424f)
                curveTo(5.885f, 4.421f, 5.883f, 4.415f, 5.887f, 4.402f)
                lineTo(5.858f, 4.394f)
                curveTo(5.853f, 4.411f, 5.854f, 4.427f, 5.861f, 4.439f)
                curveTo(5.865f, 4.445f, 5.87f, 4.45f, 5.877f, 4.453f)
                curveTo(5.884f, 4.456f, 5.891f, 4.456f, 5.898f, 4.454f)
                curveTo(5.911f, 4.45f, 5.923f, 4.439f, 5.932f, 4.424f)
                curveTo(5.941f, 4.409f, 5.949f, 4.388f, 5.953f, 4.361f)
                lineTo(5.923f, 4.357f)
                close()
                moveTo(5.943f, 4.523f)
                curveTo(5.954f, 4.504f, 5.965f, 4.483f, 5.969f, 4.456f)
                curveTo(5.973f, 4.429f, 5.969f, 4.397f, 5.952f, 4.354f)
                lineTo(5.924f, 4.364f)
                curveTo(5.94f, 4.405f, 5.943f, 4.432f, 5.94f, 4.452f)
                curveTo(5.937f, 4.473f, 5.928f, 4.489f, 5.917f, 4.508f)
                lineTo(5.943f, 4.523f)
                close()
                moveTo(5.917f, 4.582f)
                curveTo(5.923f, 4.558f, 5.933f, 4.541f, 5.943f, 4.523f)
                lineTo(5.917f, 4.508f)
                curveTo(5.906f, 4.526f, 5.895f, 4.547f, 5.888f, 4.574f)
                lineTo(5.917f, 4.582f)
                close()
                moveTo(5.969f, 4.519f)
                curveTo(5.956f, 4.554f, 5.935f, 4.575f, 5.921f, 4.583f)
                curveTo(5.917f, 4.585f, 5.915f, 4.585f, 5.913f, 4.586f)
                curveTo(5.912f, 4.586f, 5.912f, 4.585f, 5.913f, 4.586f)
                curveTo(5.918f, 4.589f, 5.914f, 4.592f, 5.917f, 4.582f)
                lineTo(5.888f, 4.574f)
                curveTo(5.884f, 4.587f, 5.884f, 4.604f, 5.898f, 4.612f)
                curveTo(5.905f, 4.616f, 5.911f, 4.616f, 5.917f, 4.615f)
                curveTo(5.923f, 4.614f, 5.929f, 4.612f, 5.935f, 4.609f)
                curveTo(5.957f, 4.597f, 5.983f, 4.569f, 5.997f, 4.529f)
                lineTo(5.969f, 4.519f)
                close()
                moveTo(5.984f, 4.72f)
                curveTo(5.995f, 4.701f, 6.008f, 4.676f, 6.013f, 4.643f)
                curveTo(6.019f, 4.61f, 6.016f, 4.57f, 5.997f, 4.519f)
                lineTo(5.969f, 4.529f)
                curveTo(5.986f, 4.577f, 5.988f, 4.612f, 5.984f, 4.639f)
                curveTo(5.979f, 4.666f, 5.968f, 4.686f, 5.958f, 4.706f)
                lineTo(5.984f, 4.72f)
                close()
                moveTo(5.986f, 4.794f)
                curveTo(5.978f, 4.794f, 5.974f, 4.792f, 5.972f, 4.79f)
                curveTo(5.97f, 4.787f, 5.968f, 4.783f, 5.968f, 4.776f)
                curveTo(5.967f, 4.761f, 5.973f, 4.74f, 5.984f, 4.72f)
                lineTo(5.958f, 4.706f)
                curveTo(5.945f, 4.728f, 5.936f, 4.755f, 5.938f, 4.778f)
                curveTo(5.938f, 4.789f, 5.942f, 4.801f, 5.95f, 4.81f)
                curveTo(5.959f, 4.82f, 5.972f, 4.824f, 5.986f, 4.824f)
                verticalLineTo(4.794f)
                close()
                moveTo(6.063f, 4.72f)
                curveTo(6.054f, 4.739f, 6.045f, 4.757f, 6.033f, 4.772f)
                curveTo(6.021f, 4.785f, 6.006f, 4.794f, 5.986f, 4.794f)
                verticalLineTo(4.824f)
                curveTo(6.017f, 4.824f, 6.039f, 4.81f, 6.055f, 4.791f)
                curveTo(6.071f, 4.773f, 6.082f, 4.751f, 6.09f, 4.733f)
                lineTo(6.063f, 4.72f)
                close()
                moveTo(6.112f, 4.668f)
                curveTo(6.097f, 4.668f, 6.087f, 4.678f, 6.081f, 4.687f)
                curveTo(6.075f, 4.696f, 6.069f, 4.708f, 6.063f, 4.72f)
                lineTo(6.09f, 4.733f)
                curveTo(6.096f, 4.721f, 6.101f, 4.711f, 6.106f, 4.705f)
                curveTo(6.108f, 4.701f, 6.11f, 4.7f, 6.111f, 4.699f)
                curveTo(6.111f, 4.698f, 6.112f, 4.698f, 6.112f, 4.698f)
                curveTo(6.112f, 4.698f, 6.112f, 4.698f, 6.112f, 4.698f)
                verticalLineTo(4.668f)
                close()
                moveTo(6.127f, 5.52f)
                verticalLineTo(4.683f)
                horizontalLineTo(6.097f)
                verticalLineTo(5.52f)
                horizontalLineTo(6.127f)
                close()
                moveTo(5.167f, 5.535f)
                horizontalLineTo(6.112f)
                verticalLineTo(5.505f)
                horizontalLineTo(5.167f)
                verticalLineTo(5.535f)
                close()
                moveTo(7.878f, 3.952f)
                curveTo(7.856f, 3.953f, 7.838f, 3.964f, 7.826f, 3.978f)
                curveTo(7.815f, 3.993f, 7.807f, 4.011f, 7.803f, 4.027f)
                curveTo(7.799f, 4.044f, 7.797f, 4.061f, 7.796f, 4.073f)
                curveTo(7.795f, 4.079f, 7.795f, 4.084f, 7.795f, 4.087f)
                curveTo(7.795f, 4.089f, 7.795f, 4.091f, 7.795f, 4.092f)
                curveTo(7.795f, 4.092f, 7.795f, 4.093f, 7.795f, 4.093f)
                curveTo(7.795f, 4.093f, 7.795f, 4.093f, 7.795f, 4.093f)
                curveTo(7.795f, 4.093f, 7.795f, 4.093f, 7.795f, 4.093f)
                curveTo(7.795f, 4.093f, 7.795f, 4.093f, 7.795f, 4.093f)
                curveTo(7.795f, 4.093f, 7.795f, 4.093f, 7.795f, 4.093f)
                curveTo(7.795f, 4.093f, 7.795f, 4.093f, 7.81f, 4.093f)
                curveTo(7.825f, 4.093f, 7.825f, 4.093f, 7.825f, 4.093f)
                curveTo(7.825f, 4.093f, 7.825f, 4.093f, 7.825f, 4.093f)
                curveTo(7.825f, 4.093f, 7.825f, 4.093f, 7.825f, 4.093f)
                curveTo(7.825f, 4.093f, 7.825f, 4.093f, 7.825f, 4.093f)
                curveTo(7.825f, 4.093f, 7.825f, 4.093f, 7.825f, 4.092f)
                curveTo(7.825f, 4.092f, 7.825f, 4.092f, 7.825f, 4.092f)
                curveTo(7.825f, 4.091f, 7.825f, 4.09f, 7.825f, 4.088f)
                curveTo(7.825f, 4.085f, 7.825f, 4.08f, 7.826f, 4.075f)
                curveTo(7.826f, 4.064f, 7.828f, 4.049f, 7.832f, 4.035f)
                curveTo(7.836f, 4.02f, 7.842f, 4.007f, 7.849f, 3.997f)
                curveTo(7.857f, 3.988f, 7.867f, 3.983f, 7.88f, 3.982f)
                lineTo(7.878f, 3.952f)
                close()
                moveTo(7.945f, 4.093f)
                curveTo(7.96f, 4.093f, 7.96f, 4.093f, 7.96f, 4.093f)
                curveTo(7.96f, 4.093f, 7.96f, 4.093f, 7.96f, 4.093f)
                curveTo(7.96f, 4.093f, 7.96f, 4.093f, 7.96f, 4.093f)
                curveTo(7.96f, 4.093f, 7.96f, 4.093f, 7.96f, 4.093f)
                curveTo(7.96f, 4.093f, 7.96f, 4.093f, 7.96f, 4.093f)
                curveTo(7.96f, 4.093f, 7.96f, 4.092f, 7.96f, 4.092f)
                curveTo(7.96f, 4.091f, 7.96f, 4.089f, 7.96f, 4.087f)
                curveTo(7.96f, 4.084f, 7.96f, 4.079f, 7.959f, 4.072f)
                curveTo(7.959f, 4.06f, 7.957f, 4.043f, 7.952f, 4.026f)
                curveTo(7.948f, 4.01f, 7.942f, 3.992f, 7.93f, 3.977f)
                curveTo(7.918f, 3.963f, 7.902f, 3.952f, 7.879f, 3.952f)
                verticalLineTo(3.982f)
                curveTo(7.891f, 3.982f, 7.9f, 3.987f, 7.907f, 3.996f)
                curveTo(7.914f, 4.005f, 7.92f, 4.019f, 7.923f, 4.034f)
                curveTo(7.927f, 4.048f, 7.929f, 4.063f, 7.929f, 4.074f)
                curveTo(7.93f, 4.08f, 7.93f, 4.085f, 7.93f, 4.088f)
                curveTo(7.93f, 4.089f, 7.93f, 4.091f, 7.93f, 4.091f)
                curveTo(7.93f, 4.092f, 7.93f, 4.092f, 7.93f, 4.092f)
                curveTo(7.93f, 4.093f, 7.93f, 4.093f, 7.93f, 4.093f)
                curveTo(7.93f, 4.093f, 7.93f, 4.093f, 7.93f, 4.093f)
                curveTo(7.93f, 4.093f, 7.93f, 4.093f, 7.93f, 4.093f)
                curveTo(7.93f, 4.093f, 7.93f, 4.093f, 7.93f, 4.093f)
                curveTo(7.93f, 4.093f, 7.93f, 4.093f, 7.945f, 4.093f)
                close()
                moveTo(7.81f, 4.108f)
                horizontalLineTo(7.945f)
                verticalLineTo(4.078f)
                horizontalLineTo(7.81f)
                verticalLineTo(4.108f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun CambodiaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.Cambodia,
            contentDescription = "Cambodia Flag"
        )
    }
}
